// this file was prevaled
// This file needs to be a JavaScript file using CommonJS to be compatiable with preval
module.exports = {
  "theme": {
    "animation": {
      "easeOutCubic": "cubic-bezier(0.33, 1, 0.68, 1)"
    },
    "borderWidths": [0, "1px"],
    "breakpoints": ["544px", "768px", "1012px", "1280px"],
    "fonts": {
      "normal": "-apple-system, BlinkMacSystemFont, \"Segoe UI\", Helvetica, Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\"",
      "mono": "SFMono-Regular, Consolas, \"Liberation Mono\", Menlo, Courier, monospace"
    },
    "fontSizes": ["12px", "14px", "16px", "20px", "24px", "32px", "40px", "48px"],
    "fontWeights": {
      "light": 300,
      "normal": 400,
      "semibold": 500,
      "bold": 600
    },
    "lineHeights": {
      "condensedUltra": 1,
      "condensed": 1.25,
      "default": 1.5
    },
    "radii": ["0", "3px", "6px", "100px"],
    "sizes": {
      "small": "544px",
      "medium": "768px",
      "large": "1012px",
      "xlarge": "1280px"
    },
    "space": ["0", "4px", "8px", "16px", "24px", "32px", "40px", "48px", "64px", "80px", "96px", "112px", "128px"],
    "colorSchemes": {
      "light": {
        "colors": {
          "auto": {
            "black": "#1b1f24",
            "white": "#ffffff",
            "gray": ["#f6f8fa", "#eaeef2", "#d0d7de", "#afb8c1", "#8c959f", "#6e7781", "#57606a", "#424a53", "#32383f", "#24292f"],
            "blue": ["#ddf4ff", "#b6e3ff", "#80ccff", "#54aeff", "#218bff", "#0969da", "#0550ae", "#033d8b", "#0a3069", "#002155"],
            "green": ["#dafbe1", "#aceebb", "#6fdd8b", "#4ac26b", "#2da44e", "#1a7f37", "#116329", "#044f1e", "#003d16", "#002d11"],
            "yellow": ["#fff8c5", "#fae17d", "#eac54f", "#d4a72c", "#bf8700", "#9a6700", "#7d4e00", "#633c01", "#4d2d00", "#3b2300"],
            "orange": ["#fff1e5", "#ffd8b5", "#ffb77c", "#fb8f44", "#e16f24", "#bc4c00", "#953800", "#762c00", "#5c2200", "#471700"],
            "red": ["#FFEBE9", "#ffcecb", "#ffaba8", "#ff8182", "#fa4549", "#cf222e", "#a40e26", "#82071e", "#660018", "#4c0014"],
            "purple": ["#fbefff", "#ecd8ff", "#d8b9ff", "#c297ff", "#a475f9", "#8250df", "#6639ba", "#512a97", "#3e1f79", "#2e1461"],
            "pink": ["#ffeff7", "#ffd3eb", "#ffadda", "#ff80c8", "#e85aad", "#bf3989", "#99286e", "#772057", "#611347", "#4d0336"]
          },
          "text": {
            "primary": "#24292f",
            "secondary": "#57606a",
            "tertiary": "#57606a",
            "placeholder": "#6e7781",
            "disabled": "#57606a",
            "inverse": "#ffffff",
            "link": "#0969da",
            "danger": "#cf222e",
            "success": "#1a7f37",
            "warning": "#9a6700",
            "white": "#ffffff"
          },
          "icon": {
            "primary": "#24292f",
            "secondary": "#57606a",
            "tertiary": "#57606a",
            "info": "#0969da",
            "danger": "#cf222e",
            "success": "#1a7f37",
            "warning": "#9a6700"
          },
          "border": {
            "primary": "#d0d7de",
            "secondary": "hsla(210,18%,87%,1)",
            "tertiary": "#d0d7de",
            "overlay": "#d0d7de",
            "inverse": "#ffffff",
            "info": "#0969da",
            "danger": "#cf222e",
            "success": "#2da44e",
            "warning": "#bf8700",
            "default": "#d0d7de",
            "muted": "hsla(210,18%,87%,1)",
            "subtle": "rgba(27,31,36,0.15)"
          },
          "bg": {
            "canvas": "#ffffff",
            "canvasMobile": "rgba(0,0,0,0)",
            "canvasInverse": "#6e7781",
            "canvasInset": "#f6f8fa",
            "primary": "#ffffff",
            "secondary": "#f6f8fa",
            "tertiary": "#f6f8fa",
            "overlay": "#ffffff",
            "backdrop": "rgba(27,31,36,0.5)",
            "info": "#ddf4ff",
            "infoInverse": "#0969da",
            "danger": "#FFEBE9",
            "dangerInverse": "#cf222e",
            "success": "#dafbe1",
            "successInverse": "#2da44e",
            "warning": "#fff8c5",
            "warningInverse": "#bf8700"
          },
          "state": {
            "hover": {
              "primaryBg": "#0969da",
              "primaryBorder": "#0969da",
              "primaryText": "#ffffff",
              "primaryIcon": "#ffffff",
              "secondaryBg": "rgba(234,238,242,0.5)",
              "secondaryBorder": "rgba(234,238,242,0.5)"
            },
            "selected": {
              "primaryBg": "#0969da",
              "primaryBorder": "#0969da",
              "primaryText": "#ffffff",
              "primaryIcon": "#ffffff"
            },
            "focus": {
              "border": "#0969da"
            }
          },
          "fade": {
            "fg10": "rgba(27,31,36,0.1)",
            "fg15": "rgba(27,31,36,0.15)",
            "fg30": "rgba(27,31,36,0.3)",
            "fg50": "rgba(27,31,36,0.5)",
            "fg70": "rgba(27,31,36,0.7)",
            "fg85": "rgba(27,31,36,0.85)",
            "black10": "rgba(27,31,36,0.1)",
            "black15": "rgba(27,31,36,0.15)",
            "black30": "rgba(27,31,36,0.3)",
            "black50": "rgba(27,31,36,0.5)",
            "black70": "rgba(27,31,36,0.7)",
            "black85": "rgba(27,31,36,0.85)",
            "white10": "rgba(255,255,255,0.1)",
            "white15": "rgba(255,255,255,0.15)",
            "white30": "rgba(255,255,255,0.3)",
            "white50": "rgba(255,255,255,0.5)",
            "white70": "rgba(255,255,255,0.7)",
            "white85": "rgba(255,255,255,0.85)"
          },
          "alert": {
            "info": {
              "text": "#24292f",
              "icon": "#0969da",
              "bg": "#ddf4ff",
              "border": "rgba(84,174,255,0.4)"
            },
            "warn": {
              "text": "#24292f",
              "icon": "#9a6700",
              "bg": "#fff8c5",
              "border": "rgba(212,167,44,0.4)"
            },
            "error": {
              "text": "#24292f",
              "icon": "#cf222e",
              "bg": "#FFEBE9",
              "border": "rgba(255,129,130,0.4)"
            },
            "success": {
              "text": "#24292f",
              "icon": "#1a7f37",
              "bg": "#dafbe1",
              "border": "rgba(74,194,107,0.4)"
            }
          },
          "autocomplete": {
            "rowBorder": "hsla(210,18%,87%,1)"
          },
          "blankslate": {
            "icon": "#57606a"
          },
          "counter": {
            "text": "#24292f",
            "bg": "rgba(175,184,193,0.2)",
            "primary": {
              "text": "#ffffff",
              "bg": "#6e7781"
            },
            "secondary": {
              "text": "#57606a",
              "bg": "rgba(234,238,242,0.5)"
            }
          },
          "box": {
            "blueBorder": "rgba(84,174,255,0.4)",
            "rowYellowBg": "#fff8c5",
            "rowBlueBg": "#ddf4ff",
            "headerBlueBg": "#ddf4ff",
            "headerBlueBorder": "rgba(84,174,255,0.4)",
            "borderInfo": "rgba(84,174,255,0.4)",
            "bgInfo": "#ddf4ff",
            "borderWarning": "rgba(212,167,44,0.4)",
            "bgWarning": "#fff8c5"
          },
          "branchName": {
            "text": "#57606a",
            "icon": "#57606a",
            "bg": "#ddf4ff",
            "link": {
              "text": "#0969da",
              "icon": "#0969da",
              "bg": "#ddf4ff"
            }
          },
          "markdown": {
            "codeBg": "rgba(175,184,193,0.2)",
            "frameBorder": "#d0d7de",
            "blockquoteBorder": "#d0d7de",
            "tableBorder": "#d0d7de",
            "tableTrBorder": "hsla(210,18%,87%,1)"
          },
          "filterItem": {
            "barBg": "rgba(234,238,242,0.5)"
          },
          "hiddenTextExpander": {
            "bg": "rgba(175,184,193,0.2)",
            "bgHover": "rgba(84,174,255,0.4)"
          },
          "dragAndDrop": {
            "border": "#d0d7de"
          },
          "uploadEnabled": {
            "border": "#d0d7de",
            "borderFocused": "#0969da"
          },
          "previewableCommentForm": {
            "border": "#d0d7de"
          },
          "verifiedBadge": {
            "text": "#1a7f37",
            "bg": "#ffffff",
            "border": "#d0d7de"
          },
          "socialCount": {
            "bg": "#ffffff"
          },
          "tooltip": {
            "text": "#ffffff",
            "bg": "#24292f"
          },
          "filesExplorerIcon": "#0969da",
          "hlAuthorBg": "#ddf4ff",
          "hlAuthorBorder": "rgba(84,174,255,0.4)",
          "logoSubdued": "rgba(175,184,193,0.2)",
          "discussionBorder": "rgba(74,194,107,0.4)",
          "discussionBgSuccess": "#2da44e",
          "actionsWorkflowTableStickyBg": "rgba(255,255,255,0.95)",
          "repoLanguageColorBorder": "rgba(27,31,36,0.1)",
          "codeSelectionBg": "rgba(84,174,255,0.4)",
          "highlight": {
            "text": "#24292f",
            "bg": "#fff8c5"
          },
          "blob": {
            "lineHighlightBg": "#fff8c5",
            "lineHighlightBorder": "rgba(212,167,44,0.4)"
          },
          "topicTag": {
            "text": "#0969da",
            "bg": "#ddf4ff",
            "hoverBg": "#0969da",
            "activeBg": "#ddf4ff",
            "border": "rgba(0,0,0,0)"
          },
          "footerInvertocat": {
            "octicon": "#6e7781",
            "octiconHover": "#57606a"
          },
          "label": {
            "border": "#d0d7de",
            "primary": {
              "text": "#24292f",
              "border": "#6e7781"
            },
            "secondary": {
              "text": "#57606a",
              "border": "#d0d7de"
            },
            "info": {
              "text": "#0969da",
              "border": "#0969da"
            },
            "success": {
              "text": "#1a7f37",
              "border": "#2da44e"
            },
            "warning": {
              "text": "#9a6700",
              "border": "#bf8700"
            },
            "danger": {
              "text": "#cf222e",
              "border": "#cf222e"
            },
            "orange": {
              "text": "#bc4c00",
              "border": "#bc4c00"
            }
          },
          "input": {
            "bg": "#ffffff",
            "contrastBg": "#f6f8fa",
            "border": "#d0d7de",
            "disabledBorder": "#d0d7de",
            "warningBorder": "#bf8700",
            "errorBorder": "#cf222e",
            "tooltip": {
              "success": {
                "text": "#24292f",
                "bg": "#dafbe1",
                "border": "rgba(74,194,107,0.4)"
              },
              "warning": {
                "text": "#24292f",
                "bg": "#fff8c5",
                "border": "rgba(212,167,44,0.4)"
              },
              "error": {
                "text": "#24292f",
                "bg": "#FFEBE9",
                "border": "rgba(255,129,130,0.4)"
              }
            },
            "disabledBg": "rgba(175,184,193,0.2)"
          },
          "toast": {
            "text": "#24292f",
            "bg": "#ffffff",
            "border": "#d0d7de",
            "icon": "#ffffff",
            "iconBg": "#0969da",
            "iconBorder": "rgba(0,0,0,0)",
            "success": {
              "text": "#24292f",
              "border": "#d0d7de",
              "icon": "#ffffff",
              "iconBg": "#2da44e",
              "iconBorder": "rgba(0,0,0,0)"
            },
            "warning": {
              "text": "#24292f",
              "border": "#d0d7de",
              "icon": "#24292f",
              "iconBg": "#bf8700",
              "iconBorder": "rgba(0,0,0,0)"
            },
            "danger": {
              "text": "#24292f",
              "border": "#d0d7de",
              "icon": "#ffffff",
              "iconBg": "#cf222e",
              "iconBorder": "rgba(0,0,0,0)"
            },
            "loading": {
              "text": "#24292f",
              "border": "#d0d7de",
              "icon": "#ffffff",
              "iconBg": "#6e7781",
              "iconBorder": "rgba(0,0,0,0)"
            }
          },
          "timeline": {
            "text": "#57606a",
            "badgeSuccessBorder": "rgba(0,0,0,0)",
            "targetBadgeBorder": "#0969da",
            "targetBadgeShadow": "rgba(84,174,255,0.4)",
            "badgeBg": "#eaeef2"
          },
          "diffstat": {
            "neutralBg": "rgba(175,184,193,0.2)",
            "neutralBorder": "rgba(27,31,36,0.15)",
            "deletionBorder": "rgba(27,31,36,0.15)",
            "additionBorder": "rgba(27,31,36,0.15)",
            "deletionBg": "#cf222e",
            "additionBg": "#2da44e"
          },
          "diff": {
            "addition": {
              "text": "#24292f",
              "bg": "#dafbe1",
              "border": "rgba(74,194,107,0.4)"
            },
            "deletion": {
              "text": "#24292f",
              "bg": "#FFEBE9",
              "border": "rgba(255,129,130,0.4)"
            },
            "change": {
              "text": "#9a6700",
              "bg": "#fff8c5",
              "border": "rgba(212,167,44,0.4)"
            }
          },
          "mergeBox": {
            "successIconBg": "#2da44e",
            "successIconText": "#ffffff",
            "successIconBorder": "rgba(0,0,0,0)",
            "successIndicatorBg": "#2da44e",
            "successIndicatorBorder": "rgba(0,0,0,0)",
            "mergedIconBg": "#8250df",
            "mergedIconText": "#ffffff",
            "mergedIconBorder": "rgba(0,0,0,0)",
            "mergedBoxBorder": "#8250df",
            "neutralIconBg": "#6e7781",
            "neutralIconText": "#ffffff",
            "neutralIconBorder": "rgba(0,0,0,0)",
            "neutralIndicatorBg": "#6e7781",
            "neutralIndicatorBorder": "rgba(0,0,0,0)",
            "warningIconBg": "#bf8700",
            "warningIconText": "#ffffff",
            "warningIconBorder": "rgba(0,0,0,0)",
            "warningBoxBorder": "#bf8700",
            "warningMergeHighlight": "rgba(0,0,0,0)",
            "errorIconBg": "#cf222e",
            "errorIconText": "#ffffff",
            "errorIconBorder": "rgba(0,0,0,0)",
            "errorIndicatorBg": "#cf222e",
            "errorIndicatorBorder": "rgba(0,0,0,0)"
          },
          "underlinenav": {
            "border": "rgba(0,0,0,0)",
            "borderHover": "rgba(175,184,193,0.2)",
            "borderActive": "#FD8C73",
            "text": "#24292f",
            "textHover": "#24292f",
            "textActive": "#24292f",
            "icon": "#6e7781",
            "iconHover": "#6e7781",
            "iconActive": "#24292f",
            "counterText": "#24292f",
            "counterBg": "rgba(175,184,193,0.2)"
          },
          "selectMenu": {
            "borderSecondary": "hsla(210,18%,87%,1)",
            "backdropBg": "rgba(27,31,36,0.5)",
            "backdropBorder": "rgba(0,0,0,0)",
            "tapHighlight": "rgba(175,184,193,0.5)",
            "tapFocusBg": "#b6e3ff"
          },
          "sidenav": {
            "borderActive": "#FD8C73",
            "selectedBg": "#ffffff"
          },
          "menu": {
            "headingText": "#24292f",
            "borderActive": "#FD8C73",
            "bgActive": "rgba(0,0,0,0)"
          },
          "project": {
            "cardBg": "#ffffff",
            "headerBg": "#24292f",
            "sidebarBg": "#ffffff",
            "gradientIn": "#ffffff",
            "gradientOut": "rgba(255,255,255,0)"
          },
          "prState": {
            "draft": {
              "text": "#ffffff",
              "bg": "#6e7781",
              "border": "rgba(0,0,0,0)"
            },
            "open": {
              "text": "#ffffff",
              "bg": "#2da44e",
              "border": "rgba(0,0,0,0)"
            },
            "merged": {
              "text": "#ffffff",
              "bg": "#8250df",
              "border": "rgba(0,0,0,0)"
            },
            "closed": {
              "text": "#ffffff",
              "bg": "#cf222e",
              "border": "rgba(0,0,0,0)"
            }
          },
          "diffBlob": {
            "numText": "#6e7781",
            "numHoverText": "#24292f",
            "addition": {
              "numHoverText": "#24292f",
              "numText": "#24292f",
              "fg": "#24292f",
              "numBg": "#CCFFD8",
              "lineBg": "#E6FFEC",
              "wordBg": "#ABF2BC"
            },
            "deletion": {
              "numHoverText": "#24292f",
              "numText": "#24292f",
              "fg": "#24292f",
              "numBg": "#FFD7D5",
              "lineBg": "#FFEBE9",
              "wordBg": "rgba(255,129,130,0.4)"
            },
            "hunk": {
              "text": "#57606a",
              "numBg": "rgba(84,174,255,0.4)",
              "lineBg": "#ddf4ff"
            },
            "emptyBlockBg": "rgba(234,238,242,0.5)",
            "selectedLineHighlightBg": "#fff8c5",
            "selectedLineHighlightBorder": "rgba(212,167,44,0.4)",
            "expander": {
              "hoverIcon": "#ffffff",
              "hoverBg": "#0969da",
              "icon": "#57606a"
            },
            "commentButton": {
              "icon": "#ffffff",
              "bg": "#0969da",
              "gradientBg": "rgba(0,0,0,0)"
            }
          },
          "globalNav": {
            "logo": "#ffffff",
            "bg": "#24292f",
            "text": "#ffffff",
            "icon": "#ffffff",
            "inputBg": "#f6f8fa",
            "inputBorder": "#f6f8fa",
            "inputIcon": "#afb8c1",
            "inputPlaceholder": "#8c959f"
          },
          "introShelf": {
            "gradientLeft": "#ddf4ff",
            "gradientRight": "#dafbe1",
            "gradientIn": "#ffffff",
            "gradientOut": "rgba(255,255,255,0)"
          },
          "canvasDefaultTransparent": "rgba(255,255,255,0)",
          "marketingIcon": {
            "primary": "#218bff",
            "secondary": "#54aeff"
          },
          "searchKeyword": {
            "hl": "#fff8c5"
          },
          "prettylights": {
            "syntax": {
              "comment": "#6e7781",
              "constant": "#0550ae",
              "entity": "#8250df",
              "storageModifierImport": "#24292f",
              "entityTag": "#116329",
              "keyword": "#cf222e",
              "string": "#0a3069",
              "variable": "#953800",
              "brackethighlighterUnmatched": "#82071e",
              "invalidIllegalText": "#f6f8fa",
              "invalidIllegalBg": "#82071e",
              "carriageReturnText": "#f6f8fa",
              "carriageReturnBg": "#cf222e",
              "stringRegexp": "#116329",
              "markupList": "#3b2300",
              "markupHeading": "#0550ae",
              "markupItalic": "#24292f",
              "markupBold": "#24292f",
              "markupDeletedText": "#82071e",
              "markupDeletedBg": "#FFEBE9",
              "markupInsertedText": "#116329",
              "markupInsertedBg": "#dafbe1",
              "markupChangedText": "#953800",
              "markupChangedBg": "#ffd8b5",
              "markupIgnoredText": "#eaeef2",
              "markupIgnoredBg": "#0550ae",
              "metaDiffRange": "#8250df",
              "brackethighlighterAngle": "#57606a",
              "sublimelinterGutterMark": "#8c959f",
              "constantOtherReferenceLink": "#0a3069"
            }
          },
          "codemirror": {
            "text": "#24292f",
            "bg": "#ffffff",
            "guttersBg": "#ffffff",
            "guttermarkerText": "#ffffff",
            "guttermarkerSubtleText": "#6e7781",
            "linenumberText": "#57606a",
            "cursor": "#24292f",
            "selectionBg": "rgba(84,174,255,0.4)",
            "activelineBg": "rgba(234,238,242,0.5)",
            "matchingbracketText": "#24292f",
            "linesBg": "#ffffff",
            "syntax": {
              "comment": "#24292f",
              "constant": "#0550ae",
              "entity": "#8250df",
              "keyword": "#cf222e",
              "storage": "#cf222e",
              "string": "#0a3069",
              "support": "#0550ae",
              "variable": "#953800"
            }
          },
          "checks": {
            "bg": "#24292f",
            "textPrimary": "#f6f8fa",
            "textSecondary": "#8c959f",
            "textLink": "#54aeff",
            "btnIcon": "#afb8c1",
            "btnHoverIcon": "#f6f8fa",
            "btnHoverBg": "rgba(255,255,255,0.125)",
            "inputText": "#eaeef2",
            "inputPlaceholderText": "#8c959f",
            "inputFocusText": "#8c959f",
            "inputBg": "#32383f",
            "donutError": "#fa4549",
            "donutPending": "#bf8700",
            "donutSuccess": "#2da44e",
            "donutNeutral": "#afb8c1",
            "dropdownText": "#afb8c1",
            "dropdownBg": "#32383f",
            "dropdownBorder": "#424a53",
            "dropdownShadow": "rgba(27,31,36,0.3)",
            "dropdownHoverText": "#f6f8fa",
            "dropdownHoverBg": "#424a53",
            "dropdownBtnHoverText": "#f6f8fa",
            "dropdownBtnHoverBg": "#32383f",
            "scrollbarThumbBg": "#57606a",
            "headerLabelText": "#d0d7de",
            "headerLabelOpenText": "#f6f8fa",
            "headerBorder": "#32383f",
            "headerIcon": "#8c959f",
            "lineText": "#d0d7de",
            "lineNumText": "rgba(140,149,159,0.75)",
            "lineTimestampText": "#8c959f",
            "lineHoverBg": "#32383f",
            "lineSelectedBg": "rgba(33,139,255,0.15)",
            "lineSelectedNumText": "#54aeff",
            "lineDtFmText": "#24292f",
            "lineDtFmBg": "#9a6700",
            "gateBg": "rgba(125,78,0,0.15)",
            "gateText": "#d0d7de",
            "gateWaitingText": "#afb8c1",
            "stepHeaderOpenBg": "#32383f",
            "stepErrorText": "#ff8182",
            "stepWarningText": "#d4a72c",
            "loglineText": "#8c959f",
            "loglineNumText": "rgba(140,149,159,0.75)",
            "loglineDebugText": "#c297ff",
            "loglineErrorText": "#d0d7de",
            "loglineErrorNumText": "#ff8182",
            "loglineErrorBg": "rgba(164,14,38,0.15)",
            "loglineWarningText": "#d0d7de",
            "loglineWarningNumText": "#d4a72c",
            "loglineWarningBg": "rgba(125,78,0,0.15)",
            "loglineCommandText": "#54aeff",
            "loglineSectionText": "#4ac26b",
            "ansi": {
              "black": "#24292f",
              "blackBright": "#32383f",
              "white": "#d0d7de",
              "whiteBright": "#d0d7de",
              "gray": "#8c959f",
              "red": "#ff8182",
              "redBright": "#ffaba8",
              "green": "#4ac26b",
              "greenBright": "#6fdd8b",
              "yellow": "#d4a72c",
              "yellowBright": "#eac54f",
              "blue": "#54aeff",
              "blueBright": "#80ccff",
              "magenta": "#c297ff",
              "magentaBright": "#d8b9ff",
              "cyan": "#76e3ea",
              "cyanBright": "#b3f0ff"
            }
          },
          "mktg": {
            "success": "rgba(36,146,67,1)",
            "info": "rgba(19,119,234,1)",
            "bgShadeGradient": {
              "top": "rgba(27,31,36,0.065)",
              "bottom": "rgba(27,31,36,0)"
            },
            "btn": {
              "bg": {
                "top": "hsla(228,82%,66%,1)",
                "bottom": "#4969ed"
              },
              "bgOverlay": {
                "top": "hsla(228,74%,59%,1)",
                "bottom": "#3355e0"
              },
              "text": "#ffffff",
              "primary": {
                "bg": {
                  "top": "hsla(137,56%,46%,1)",
                  "bottom": "#2ea44f"
                },
                "bgOverlay": {
                  "top": "hsla(134,60%,38%,1)",
                  "bottom": "#22863a"
                },
                "text": "#ffffff"
              },
              "enterprise": {
                "bg": {
                  "top": "hsla(249,100%,72%,1)",
                  "bottom": "#6f57ff"
                },
                "bgOverlay": {
                  "top": "hsla(248,65%,63%,1)",
                  "bottom": "#614eda"
                },
                "text": "#ffffff"
              },
              "outline": {
                "text": "#4969ed",
                "border": "rgba(73,105,237,0.3)",
                "hover": {
                  "text": "#3355e0",
                  "border": "rgba(51,85,224,0.5)"
                },
                "focus": {
                  "border": "#4969ed",
                  "borderInset": "rgba(73,105,237,0.5)"
                }
              },
              "dark": {
                "text": "#ffffff",
                "border": "rgba(255,255,255,0.3)",
                "hover": {
                  "text": "#ffffff",
                  "border": "rgba(255,255,255,0.5)"
                },
                "focus": {
                  "border": "#ffffff",
                  "borderInset": "rgba(255,255,255,0.5)"
                }
              }
            }
          },
          "avatar": {
            "bg": "#ffffff",
            "border": "rgba(27,31,36,0.15)",
            "stackFade": "#afb8c1",
            "stackFadeMore": "#d0d7de"
          },
          "header": {
            "text": "rgba(255,255,255,0.7)",
            "bg": "#24292f",
            "logo": "#ffffff"
          },
          "headerSearch": {
            "bg": "#24292f",
            "border": "#57606a"
          },
          "ansi": {
            "black": "#24292f",
            "blackBright": "#57606a",
            "white": "#6e7781",
            "whiteBright": "#8c959f",
            "gray": "#6e7781",
            "red": "#cf222e",
            "redBright": "#a40e26",
            "green": "#116329",
            "greenBright": "#1a7f37",
            "yellow": "#4d2d00",
            "yellowBright": "#633c01",
            "blue": "#0969da",
            "blueBright": "#218bff",
            "magenta": "#8250df",
            "magentaBright": "#a475f9",
            "cyan": "#1b7c83",
            "cyanBright": "#3192aa"
          },
          "btn": {
            "text": "#24292f",
            "bg": "#f6f8fa",
            "border": "rgba(27,31,36,0.15)",
            "hoverBg": "#f3f4f6",
            "hoverBorder": "rgba(27,31,36,0.15)",
            "activeBg": "hsla(220,14%,93%,1)",
            "activeBorder": "rgba(27,31,36,0.15)",
            "selectedBg": "hsla(220,14%,94%,1)",
            "focusBg": "#f6f8fa",
            "focusBorder": "rgba(27,31,36,0.15)",
            "counterBg": "rgba(27,31,36,0.08)",
            "primary": {
              "text": "#ffffff",
              "bg": "#2da44e",
              "border": "rgba(27,31,36,0.15)",
              "hoverBg": "#2c974b",
              "hoverBorder": "rgba(27,31,36,0.15)",
              "selectedBg": "hsla(137,55%,36%,1)",
              "disabledText": "rgba(255,255,255,0.8)",
              "disabledBg": "#94d3a2",
              "disabledBorder": "rgba(27,31,36,0.15)",
              "focusBg": "#2da44e",
              "focusBorder": "rgba(27,31,36,0.15)",
              "icon": "rgba(255,255,255,0.8)",
              "counterBg": "rgba(255,255,255,0.2)"
            },
            "outline": {
              "text": "#0969da",
              "hoverText": "#ffffff",
              "hoverBg": "#0969da",
              "hoverBorder": "rgba(27,31,36,0.15)",
              "hoverCounterBg": "rgba(255,255,255,0.2)",
              "selectedText": "#ffffff",
              "selectedBg": "hsla(212,92%,42%,1)",
              "selectedBorder": "rgba(27,31,36,0.15)",
              "disabledText": "rgba(9,105,218,0.5)",
              "disabledBg": "#f6f8fa",
              "disabledCounterBg": "rgba(9,105,218,0.05)",
              "focusBorder": "rgba(27,31,36,0.15)",
              "counterBg": "rgba(9,105,218,0.1)"
            },
            "danger": {
              "text": "#cf222e",
              "hoverText": "#ffffff",
              "hoverBg": "#a40e26",
              "hoverBorder": "rgba(27,31,36,0.15)",
              "hoverCounterBg": "rgba(255,255,255,0.2)",
              "selectedText": "#ffffff",
              "selectedBg": "hsla(356,72%,44%,1)",
              "selectedBorder": "rgba(27,31,36,0.15)",
              "disabledText": "rgba(207,34,46,0.5)",
              "disabledBg": "#f6f8fa",
              "disabledCounterBg": "rgba(207,34,46,0.05)",
              "focusBorder": "rgba(27,31,36,0.15)",
              "counterBg": "rgba(207,34,46,0.1)",
              "icon": "#cf222e",
              "hoverIcon": "#ffffff"
            }
          },
          "fg": {
            "default": "#24292f",
            "muted": "#57606a",
            "subtle": "#6e7781",
            "onEmphasis": "#ffffff"
          },
          "canvas": {
            "default": "#ffffff",
            "overlay": "#ffffff",
            "inset": "#f6f8fa",
            "subtle": "#f6f8fa"
          },
          "neutral": {
            "emphasisPlus": "#24292f",
            "emphasis": "#6e7781",
            "muted": "rgba(175,184,193,0.2)",
            "subtle": "rgba(234,238,242,0.5)"
          },
          "accent": {
            "fg": "#0969da",
            "emphasis": "#0969da",
            "muted": "rgba(84,174,255,0.4)",
            "subtle": "#ddf4ff"
          },
          "success": {
            "fg": "#1a7f37",
            "emphasis": "#2da44e",
            "muted": "rgba(74,194,107,0.4)",
            "subtle": "#dafbe1"
          },
          "attention": {
            "fg": "#9a6700",
            "emphasis": "#bf8700",
            "muted": "rgba(212,167,44,0.4)",
            "subtle": "#fff8c5"
          },
          "severe": {
            "fg": "#bc4c00",
            "emphasis": "#bc4c00",
            "muted": "rgba(251,143,68,0.4)",
            "subtle": "#fff1e5"
          },
          "danger": {
            "fg": "#cf222e",
            "emphasis": "#cf222e",
            "muted": "rgba(255,129,130,0.4)",
            "subtle": "#FFEBE9"
          },
          "done": {
            "fg": "#8250df",
            "emphasis": "#8250df",
            "muted": "rgba(194,151,255,0.4)",
            "subtle": "#fbefff"
          },
          "sponsors": {
            "fg": "#bf3989",
            "emphasis": "#bf3989",
            "muted": "rgba(255,128,200,0.4)",
            "subtle": "#ffeff7"
          },
          "primer": {
            "canvas": {
              "backdrop": "rgba(27,31,36,0.5)",
              "sticky": "rgba(255,255,255,0.95)"
            },
            "border": {
              "active": "#FD8C73",
              "contrast": "rgba(27,31,36,0.1)"
            }
          }
        },
        "shadows": {
          "shadow": {
            "highlight": "inset 0 1px 0 rgba(255,255,255,0.25)",
            "inset": "inset 0 1px 0 rgba(208,215,222,0.2)",
            "small": "0 1px 0 rgba(27,31,36,0.04)",
            "medium": "0 3px 6px rgba(140,149,159,0.15)",
            "large": "0 8px 24px rgba(140,149,159,0.2)",
            "extraLarge": "0 12px 28px rgba(140,149,159,0.3)"
          },
          "state": {
            "focus": {
              "shadow": "0 0 0 3px rgba(9,105,218,0.3)"
            }
          },
          "autocomplete": {
            "shadow": "0 3px 6px rgba(140,149,159,0.15)"
          },
          "dropdown": {
            "shadow": "0 8px 24px rgba(140,149,159,0.2)"
          },
          "input": {
            "shadow": "inset 0 1px 0 rgba(208,215,222,0.2)"
          },
          "toast": {
            "shadow": "0 8px 24px rgba(140,149,159,0.2)"
          },
          "selectMenu": {
            "shadow": "0 8px 24px rgba(140,149,159,0.2)"
          },
          "avatar": {
            "childShadow": "-2px -2px 0 rgba(255,255,255,0.8)"
          },
          "overlay": {
            "shadow": "0 1px 3px rgba(27,31,36,0.12), 0 8px 24px rgba(66,74,83,0.12)"
          },
          "btn": {
            "shadow": "0 1px 0 rgba(27,31,36,0.04)",
            "insetShadow": "inset 0 1px 0 rgba(255,255,255,0.25)",
            "focusShadow": "0 0 0 3px rgba(9,105,218,0.3)",
            "shadowActive": "inset 0 0.15em 0.3em rgba(27,31,36,0.15)",
            "shadowInputFocus": "0 0 0 0.2em rgba(9,105,218,0.3)",
            "primary": {
              "shadow": "0 1px 0 rgba(27,31,36,0.1)",
              "insetShadow": "inset 0 1px 0 rgba(255,255,255,0.03)",
              "selectedShadow": "inset 0 1px 0 rgba(0,45,17,0.2)",
              "focusShadow": "0 0 0 3px rgba(45,164,78,0.4)"
            },
            "outline": {
              "hoverShadow": "0 1px 0 rgba(27,31,36,0.1)",
              "hoverInsetShadow": "inset 0 1px 0 rgba(255,255,255,0.03)",
              "selectedShadow": "inset 0 1px 0 rgba(0,33,85,0.2)",
              "focusShadow": "0 0 0 3px rgba(5,80,174,0.4)"
            },
            "danger": {
              "hoverShadow": "0 1px 0 rgba(27,31,36,0.1)",
              "hoverInsetShadow": "inset 0 1px 0 rgba(255,255,255,0.03)",
              "selectedShadow": "inset 0 1px 0 rgba(76,0,20,0.2)",
              "focusShadow": "0 0 0 3px rgba(164,14,38,0.4)"
            }
          },
          "primer": {
            "shadow": {
              "highlight": "inset 0 1px 0 rgba(255,255,255,0.25)",
              "inset": "inset 0 1px 0 rgba(208,215,222,0.2)",
              "focus": "0 0 0 3px rgba(9,105,218,0.3)"
            }
          }
        }
      },
      "light_protanopia": {
        "colors": {
          "auto": {
            "black": "#1b1f24",
            "white": "#ffffff",
            "gray": ["#f6f8fa", "#eaeef2", "#d0d7de", "#afb8c1", "#8c959f", "#6e7781", "#57606a", "#424a53", "#32383f", "#24292f"],
            "blue": ["#ddf4ff", "#b6e3ff", "#80ccff", "#54aeff", "#218bff", "#0969da", "#0550ae", "#033d8b", "#0a3069", "#002155"],
            "green": ["#c0f6ff", "#96e5ff", "#65ccff", "#35adff", "#0088ff", "#0566d5", "#054da9", "#033a86", "#002d68", "#001f50"],
            "yellow": ["#fff8c5", "#fae17d", "#eac54f", "#d4a72c", "#bf8700", "#9a6700", "#7d4e00", "#633c01", "#4d2d00", "#3b2300"],
            "orange": ["#fff1e5", "#ffd8b5", "#ffb77c", "#fb8f44", "#e16f24", "#bc4c00", "#953800", "#762c00", "#5c2200", "#471700"],
            "red": ["#fefe48", "#fee325", "#f8c200", "#e7a100", "#d08002", "#ac5e00", "#8b4600", "#6c3900", "#4c3100", "#2f2900"],
            "purple": ["#fbefff", "#ecd8ff", "#d8b9ff", "#c297ff", "#a475f9", "#8250df", "#6639ba", "#512a97", "#3e1f79", "#2e1461"],
            "pink": ["#ffeff7", "#ffd3eb", "#ffadda", "#ff80c8", "#e85aad", "#bf3989", "#99286e", "#772057", "#611347", "#4d0336"]
          },
          "text": {
            "primary": "#24292f",
            "secondary": "#57606a",
            "tertiary": "#57606a",
            "placeholder": "#6e7781",
            "disabled": "#57606a",
            "inverse": "#ffffff",
            "link": "#0969da",
            "danger": "#ac5e00",
            "success": "#0566d5",
            "warning": "#9a6700",
            "white": "#ffffff"
          },
          "icon": {
            "primary": "#24292f",
            "secondary": "#57606a",
            "tertiary": "#57606a",
            "info": "#0969da",
            "danger": "#ac5e00",
            "success": "#0566d5",
            "warning": "#9a6700"
          },
          "border": {
            "primary": "#d0d7de",
            "secondary": "hsla(210,18%,87%,1)",
            "tertiary": "#d0d7de",
            "overlay": "#d0d7de",
            "inverse": "#ffffff",
            "info": "#0969da",
            "danger": "#ac5e00",
            "success": "#0088ff",
            "warning": "#bf8700",
            "default": "#d0d7de",
            "muted": "hsla(210,18%,87%,1)",
            "subtle": "rgba(27,31,36,0.15)"
          },
          "bg": {
            "canvas": "#ffffff",
            "canvasMobile": "rgba(0,0,0,0)",
            "canvasInverse": "#6e7781",
            "canvasInset": "#f6f8fa",
            "primary": "#ffffff",
            "secondary": "#f6f8fa",
            "tertiary": "#f6f8fa",
            "overlay": "#ffffff",
            "backdrop": "rgba(27,31,36,0.5)",
            "info": "#ddf4ff",
            "infoInverse": "#0969da",
            "danger": "#fefe48",
            "dangerInverse": "#ac5e00",
            "success": "#c0f6ff",
            "successInverse": "#0088ff",
            "warning": "#fff8c5",
            "warningInverse": "#bf8700"
          },
          "state": {
            "hover": {
              "primaryBg": "#0969da",
              "primaryBorder": "#0969da",
              "primaryText": "#ffffff",
              "primaryIcon": "#ffffff",
              "secondaryBg": "rgba(234,238,242,0.5)",
              "secondaryBorder": "rgba(234,238,242,0.5)"
            },
            "selected": {
              "primaryBg": "#0969da",
              "primaryBorder": "#0969da",
              "primaryText": "#ffffff",
              "primaryIcon": "#ffffff"
            },
            "focus": {
              "border": "#0969da"
            }
          },
          "fade": {
            "fg10": "rgba(27,31,36,0.1)",
            "fg15": "rgba(27,31,36,0.15)",
            "fg30": "rgba(27,31,36,0.3)",
            "fg50": "rgba(27,31,36,0.5)",
            "fg70": "rgba(27,31,36,0.7)",
            "fg85": "rgba(27,31,36,0.85)",
            "black10": "rgba(27,31,36,0.1)",
            "black15": "rgba(27,31,36,0.15)",
            "black30": "rgba(27,31,36,0.3)",
            "black50": "rgba(27,31,36,0.5)",
            "black70": "rgba(27,31,36,0.7)",
            "black85": "rgba(27,31,36,0.85)",
            "white10": "rgba(255,255,255,0.1)",
            "white15": "rgba(255,255,255,0.15)",
            "white30": "rgba(255,255,255,0.3)",
            "white50": "rgba(255,255,255,0.5)",
            "white70": "rgba(255,255,255,0.7)",
            "white85": "rgba(255,255,255,0.85)"
          },
          "alert": {
            "info": {
              "text": "#24292f",
              "icon": "#0969da",
              "bg": "#ddf4ff",
              "border": "rgba(84,174,255,0.4)"
            },
            "warn": {
              "text": "#24292f",
              "icon": "#9a6700",
              "bg": "#fff8c5",
              "border": "rgba(212,167,44,0.4)"
            },
            "error": {
              "text": "#24292f",
              "icon": "#ac5e00",
              "bg": "#fefe48",
              "border": "rgba(231,161,0,0.4)"
            },
            "success": {
              "text": "#24292f",
              "icon": "#0566d5",
              "bg": "#c0f6ff",
              "border": "rgba(53,173,255,0.4)"
            }
          },
          "autocomplete": {
            "rowBorder": "hsla(210,18%,87%,1)"
          },
          "blankslate": {
            "icon": "#57606a"
          },
          "counter": {
            "text": "#24292f",
            "bg": "rgba(175,184,193,0.2)",
            "primary": {
              "text": "#ffffff",
              "bg": "#6e7781"
            },
            "secondary": {
              "text": "#57606a",
              "bg": "rgba(234,238,242,0.5)"
            }
          },
          "box": {
            "blueBorder": "rgba(84,174,255,0.4)",
            "rowYellowBg": "#fff8c5",
            "rowBlueBg": "#ddf4ff",
            "headerBlueBg": "#ddf4ff",
            "headerBlueBorder": "rgba(84,174,255,0.4)",
            "borderInfo": "rgba(84,174,255,0.4)",
            "bgInfo": "#ddf4ff",
            "borderWarning": "rgba(212,167,44,0.4)",
            "bgWarning": "#fff8c5"
          },
          "branchName": {
            "text": "#57606a",
            "icon": "#57606a",
            "bg": "#ddf4ff",
            "link": {
              "text": "#0969da",
              "icon": "#0969da",
              "bg": "#ddf4ff"
            }
          },
          "markdown": {
            "codeBg": "rgba(175,184,193,0.2)",
            "frameBorder": "#d0d7de",
            "blockquoteBorder": "#d0d7de",
            "tableBorder": "#d0d7de",
            "tableTrBorder": "hsla(210,18%,87%,1)"
          },
          "filterItem": {
            "barBg": "rgba(234,238,242,0.5)"
          },
          "hiddenTextExpander": {
            "bg": "rgba(175,184,193,0.2)",
            "bgHover": "rgba(84,174,255,0.4)"
          },
          "dragAndDrop": {
            "border": "#d0d7de"
          },
          "uploadEnabled": {
            "border": "#d0d7de",
            "borderFocused": "#0969da"
          },
          "previewableCommentForm": {
            "border": "#d0d7de"
          },
          "verifiedBadge": {
            "text": "#0566d5",
            "bg": "#ffffff",
            "border": "#d0d7de"
          },
          "socialCount": {
            "bg": "#ffffff"
          },
          "tooltip": {
            "text": "#ffffff",
            "bg": "#24292f"
          },
          "filesExplorerIcon": "#0969da",
          "hlAuthorBg": "#ddf4ff",
          "hlAuthorBorder": "rgba(84,174,255,0.4)",
          "logoSubdued": "rgba(175,184,193,0.2)",
          "discussionBorder": "rgba(53,173,255,0.4)",
          "discussionBgSuccess": "#0088ff",
          "actionsWorkflowTableStickyBg": "rgba(255,255,255,0.95)",
          "repoLanguageColorBorder": "rgba(27,31,36,0.1)",
          "codeSelectionBg": "rgba(84,174,255,0.4)",
          "highlight": {
            "text": "#24292f",
            "bg": "#fff8c5"
          },
          "blob": {
            "lineHighlightBg": "#fff8c5",
            "lineHighlightBorder": "rgba(212,167,44,0.4)"
          },
          "topicTag": {
            "text": "#0969da",
            "bg": "#ddf4ff",
            "hoverBg": "#0969da",
            "activeBg": "#ddf4ff",
            "border": "rgba(0,0,0,0)"
          },
          "footerInvertocat": {
            "octicon": "#6e7781",
            "octiconHover": "#57606a"
          },
          "label": {
            "border": "#d0d7de",
            "primary": {
              "text": "#24292f",
              "border": "#6e7781"
            },
            "secondary": {
              "text": "#57606a",
              "border": "#d0d7de"
            },
            "info": {
              "text": "#0969da",
              "border": "#0969da"
            },
            "success": {
              "text": "#0566d5",
              "border": "#0088ff"
            },
            "warning": {
              "text": "#9a6700",
              "border": "#bf8700"
            },
            "danger": {
              "text": "#ac5e00",
              "border": "#ac5e00"
            },
            "orange": {
              "text": "#bc4c00",
              "border": "#bc4c00"
            }
          },
          "input": {
            "bg": "#ffffff",
            "contrastBg": "#f6f8fa",
            "border": "#d0d7de",
            "disabledBorder": "#d0d7de",
            "warningBorder": "#bf8700",
            "errorBorder": "#ac5e00",
            "tooltip": {
              "success": {
                "text": "#24292f",
                "bg": "#c0f6ff",
                "border": "rgba(53,173,255,0.4)"
              },
              "warning": {
                "text": "#24292f",
                "bg": "#fff8c5",
                "border": "rgba(212,167,44,0.4)"
              },
              "error": {
                "text": "#24292f",
                "bg": "#fefe48",
                "border": "rgba(231,161,0,0.4)"
              }
            },
            "disabledBg": "rgba(175,184,193,0.2)"
          },
          "toast": {
            "text": "#24292f",
            "bg": "#ffffff",
            "border": "#d0d7de",
            "icon": "#ffffff",
            "iconBg": "#0969da",
            "iconBorder": "rgba(0,0,0,0)",
            "success": {
              "text": "#24292f",
              "border": "#d0d7de",
              "icon": "#ffffff",
              "iconBg": "#0088ff",
              "iconBorder": "rgba(0,0,0,0)"
            },
            "warning": {
              "text": "#24292f",
              "border": "#d0d7de",
              "icon": "#24292f",
              "iconBg": "#bf8700",
              "iconBorder": "rgba(0,0,0,0)"
            },
            "danger": {
              "text": "#24292f",
              "border": "#d0d7de",
              "icon": "#ffffff",
              "iconBg": "#ac5e00",
              "iconBorder": "rgba(0,0,0,0)"
            },
            "loading": {
              "text": "#24292f",
              "border": "#d0d7de",
              "icon": "#ffffff",
              "iconBg": "#6e7781",
              "iconBorder": "rgba(0,0,0,0)"
            }
          },
          "timeline": {
            "text": "#57606a",
            "badgeSuccessBorder": "rgba(0,0,0,0)",
            "targetBadgeBorder": "#0969da",
            "targetBadgeShadow": "rgba(84,174,255,0.4)",
            "badgeBg": "#eaeef2"
          },
          "diffstat": {
            "neutralBg": "rgba(175,184,193,0.2)",
            "neutralBorder": "rgba(27,31,36,0.15)",
            "deletionBorder": "rgba(27,31,36,0.15)",
            "additionBorder": "rgba(27,31,36,0.15)",
            "deletionBg": "#ac5e00",
            "additionBg": "#0088ff"
          },
          "diff": {
            "addition": {
              "text": "#24292f",
              "bg": "#c0f6ff",
              "border": "rgba(53,173,255,0.4)"
            },
            "deletion": {
              "text": "#24292f",
              "bg": "#fefe48",
              "border": "rgba(231,161,0,0.4)"
            },
            "change": {
              "text": "#9a6700",
              "bg": "#fff8c5",
              "border": "rgba(212,167,44,0.4)"
            }
          },
          "mergeBox": {
            "successIconBg": "#0088ff",
            "successIconText": "#ffffff",
            "successIconBorder": "rgba(0,0,0,0)",
            "successIndicatorBg": "#0088ff",
            "successIndicatorBorder": "rgba(0,0,0,0)",
            "mergedIconBg": "#8250df",
            "mergedIconText": "#ffffff",
            "mergedIconBorder": "rgba(0,0,0,0)",
            "mergedBoxBorder": "#8250df",
            "neutralIconBg": "#6e7781",
            "neutralIconText": "#ffffff",
            "neutralIconBorder": "rgba(0,0,0,0)",
            "neutralIndicatorBg": "#6e7781",
            "neutralIndicatorBorder": "rgba(0,0,0,0)",
            "warningIconBg": "#bf8700",
            "warningIconText": "#ffffff",
            "warningIconBorder": "rgba(0,0,0,0)",
            "warningBoxBorder": "#bf8700",
            "warningMergeHighlight": "rgba(0,0,0,0)",
            "errorIconBg": "#ac5e00",
            "errorIconText": "#ffffff",
            "errorIconBorder": "rgba(0,0,0,0)",
            "errorIndicatorBg": "#ac5e00",
            "errorIndicatorBorder": "rgba(0,0,0,0)"
          },
          "underlinenav": {
            "border": "rgba(0,0,0,0)",
            "borderHover": "rgba(175,184,193,0.2)",
            "borderActive": "#FD8C73",
            "text": "#24292f",
            "textHover": "#24292f",
            "textActive": "#24292f",
            "icon": "#6e7781",
            "iconHover": "#6e7781",
            "iconActive": "#24292f",
            "counterText": "#24292f",
            "counterBg": "rgba(175,184,193,0.2)"
          },
          "selectMenu": {
            "borderSecondary": "hsla(210,18%,87%,1)",
            "backdropBg": "rgba(27,31,36,0.5)",
            "backdropBorder": "rgba(0,0,0,0)",
            "tapHighlight": "rgba(175,184,193,0.5)",
            "tapFocusBg": "#b6e3ff"
          },
          "sidenav": {
            "borderActive": "#FD8C73",
            "selectedBg": "#ffffff"
          },
          "menu": {
            "headingText": "#24292f",
            "borderActive": "#FD8C73",
            "bgActive": "rgba(0,0,0,0)"
          },
          "project": {
            "cardBg": "#ffffff",
            "headerBg": "#24292f",
            "sidebarBg": "#ffffff",
            "gradientIn": "#ffffff",
            "gradientOut": "rgba(255,255,255,0)"
          },
          "prState": {
            "draft": {
              "text": "#ffffff",
              "bg": "#6e7781",
              "border": "rgba(0,0,0,0)"
            },
            "open": {
              "text": "#ffffff",
              "bg": "#0088ff",
              "border": "rgba(0,0,0,0)"
            },
            "merged": {
              "text": "#ffffff",
              "bg": "#8250df",
              "border": "rgba(0,0,0,0)"
            },
            "closed": {
              "text": "#ffffff",
              "bg": "#ac5e00",
              "border": "rgba(0,0,0,0)"
            }
          },
          "diffBlob": {
            "numText": "#6e7781",
            "numHoverText": "#24292f",
            "addition": {
              "numHoverText": "#24292f",
              "numText": "#24292f",
              "fg": "#24292f",
              "numBg": "rgba(53,173,255,0.4)",
              "lineBg": "rgba(192,246,255,0.5)",
              "wordBg": "rgba(53,173,255,0.4)"
            },
            "deletion": {
              "numHoverText": "#24292f",
              "numText": "#24292f",
              "fg": "#24292f",
              "numBg": "rgba(231,161,0,0.4)",
              "lineBg": "rgba(254,254,72,0.5)",
              "wordBg": "rgba(248,194,0,0.5)"
            },
            "hunk": {
              "text": "#57606a",
              "numBg": "rgba(84,174,255,0.4)",
              "lineBg": "#ddf4ff"
            },
            "emptyBlockBg": "rgba(234,238,242,0.5)",
            "selectedLineHighlightBg": "#fff8c5",
            "selectedLineHighlightBorder": "rgba(212,167,44,0.4)",
            "expander": {
              "hoverIcon": "#ffffff",
              "hoverBg": "#0969da",
              "icon": "#57606a"
            },
            "commentButton": {
              "icon": "#ffffff",
              "bg": "#0969da",
              "gradientBg": "rgba(0,0,0,0)"
            }
          },
          "globalNav": {
            "logo": "#ffffff",
            "bg": "#24292f",
            "text": "#ffffff",
            "icon": "#ffffff",
            "inputBg": "#f6f8fa",
            "inputBorder": "#f6f8fa",
            "inputIcon": "#afb8c1",
            "inputPlaceholder": "#8c959f"
          },
          "introShelf": {
            "gradientLeft": "#ddf4ff",
            "gradientRight": "#c0f6ff",
            "gradientIn": "#ffffff",
            "gradientOut": "rgba(255,255,255,0)"
          },
          "canvasDefaultTransparent": "rgba(255,255,255,0)",
          "marketingIcon": {
            "primary": "#218bff",
            "secondary": "#54aeff"
          },
          "searchKeyword": {
            "hl": "#fff8c5"
          },
          "prettylights": {
            "syntax": {
              "comment": "#6e7781",
              "constant": "#0550ae",
              "entity": "#8250df",
              "storageModifierImport": "#24292f",
              "entityTag": "#054da9",
              "keyword": "#ac5e00",
              "string": "#0a3069",
              "variable": "#953800",
              "brackethighlighterUnmatched": "#6c3900",
              "invalidIllegalText": "#f6f8fa",
              "invalidIllegalBg": "#6c3900",
              "carriageReturnText": "#f6f8fa",
              "carriageReturnBg": "#ac5e00",
              "stringRegexp": "#054da9",
              "markupList": "#3b2300",
              "markupHeading": "#0550ae",
              "markupItalic": "#24292f",
              "markupBold": "#24292f",
              "markupDeletedText": "#6c3900",
              "markupDeletedBg": "#fefe48",
              "markupInsertedText": "#054da9",
              "markupInsertedBg": "#c0f6ff",
              "markupChangedText": "#953800",
              "markupChangedBg": "#ffd8b5",
              "markupIgnoredText": "#eaeef2",
              "markupIgnoredBg": "#0550ae",
              "metaDiffRange": "#8250df",
              "brackethighlighterAngle": "#57606a",
              "sublimelinterGutterMark": "#8c959f",
              "constantOtherReferenceLink": "#0a3069"
            }
          },
          "codemirror": {
            "text": "#24292f",
            "bg": "#ffffff",
            "guttersBg": "#ffffff",
            "guttermarkerText": "#ffffff",
            "guttermarkerSubtleText": "#6e7781",
            "linenumberText": "#57606a",
            "cursor": "#24292f",
            "selectionBg": "rgba(84,174,255,0.4)",
            "activelineBg": "rgba(234,238,242,0.5)",
            "matchingbracketText": "#24292f",
            "linesBg": "#ffffff",
            "syntax": {
              "comment": "#24292f",
              "constant": "#0550ae",
              "entity": "#8250df",
              "keyword": "#ac5e00",
              "storage": "#ac5e00",
              "string": "#0a3069",
              "support": "#0550ae",
              "variable": "#953800"
            }
          },
          "checks": {
            "bg": "#24292f",
            "textPrimary": "#f6f8fa",
            "textSecondary": "#8c959f",
            "textLink": "#54aeff",
            "btnIcon": "#afb8c1",
            "btnHoverIcon": "#f6f8fa",
            "btnHoverBg": "rgba(255,255,255,0.125)",
            "inputText": "#eaeef2",
            "inputPlaceholderText": "#8c959f",
            "inputFocusText": "#8c959f",
            "inputBg": "#32383f",
            "donutError": "#d08002",
            "donutPending": "#bf8700",
            "donutSuccess": "#0088ff",
            "donutNeutral": "#afb8c1",
            "dropdownText": "#afb8c1",
            "dropdownBg": "#32383f",
            "dropdownBorder": "#424a53",
            "dropdownShadow": "rgba(27,31,36,0.3)",
            "dropdownHoverText": "#f6f8fa",
            "dropdownHoverBg": "#424a53",
            "dropdownBtnHoverText": "#f6f8fa",
            "dropdownBtnHoverBg": "#32383f",
            "scrollbarThumbBg": "#57606a",
            "headerLabelText": "#d0d7de",
            "headerLabelOpenText": "#f6f8fa",
            "headerBorder": "#32383f",
            "headerIcon": "#8c959f",
            "lineText": "#d0d7de",
            "lineNumText": "rgba(140,149,159,0.75)",
            "lineTimestampText": "#8c959f",
            "lineHoverBg": "#32383f",
            "lineSelectedBg": "rgba(33,139,255,0.15)",
            "lineSelectedNumText": "#54aeff",
            "lineDtFmText": "#24292f",
            "lineDtFmBg": "#9a6700",
            "gateBg": "rgba(125,78,0,0.15)",
            "gateText": "#d0d7de",
            "gateWaitingText": "#afb8c1",
            "stepHeaderOpenBg": "#32383f",
            "stepErrorText": "#e7a100",
            "stepWarningText": "#d4a72c",
            "loglineText": "#8c959f",
            "loglineNumText": "rgba(140,149,159,0.75)",
            "loglineDebugText": "#c297ff",
            "loglineErrorText": "#d0d7de",
            "loglineErrorNumText": "#e7a100",
            "loglineErrorBg": "rgba(139,70,0,0.15)",
            "loglineWarningText": "#d0d7de",
            "loglineWarningNumText": "#d4a72c",
            "loglineWarningBg": "rgba(125,78,0,0.15)",
            "loglineCommandText": "#54aeff",
            "loglineSectionText": "#35adff",
            "ansi": {
              "black": "#24292f",
              "blackBright": "#32383f",
              "white": "#d0d7de",
              "whiteBright": "#d0d7de",
              "gray": "#8c959f",
              "red": "#e7a100",
              "redBright": "#f8c200",
              "green": "#35adff",
              "greenBright": "#65ccff",
              "yellow": "#d4a72c",
              "yellowBright": "#eac54f",
              "blue": "#54aeff",
              "blueBright": "#80ccff",
              "magenta": "#c297ff",
              "magentaBright": "#d8b9ff",
              "cyan": "#76e3ea",
              "cyanBright": "#b3f0ff"
            }
          },
          "mktg": {
            "success": "rgba(3,119,234,1)",
            "info": "rgba(19,119,234,1)",
            "bgShadeGradient": {
              "top": "rgba(27,31,36,0.065)",
              "bottom": "rgba(27,31,36,0)"
            },
            "btn": {
              "bg": {
                "top": "hsla(228,82%,66%,1)",
                "bottom": "#4969ed"
              },
              "bgOverlay": {
                "top": "hsla(228,74%,59%,1)",
                "bottom": "#3355e0"
              },
              "text": "#ffffff",
              "primary": {
                "bg": {
                  "top": "hsla(137,56%,46%,1)",
                  "bottom": "#2ea44f"
                },
                "bgOverlay": {
                  "top": "hsla(134,60%,38%,1)",
                  "bottom": "#22863a"
                },
                "text": "#ffffff"
              },
              "enterprise": {
                "bg": {
                  "top": "hsla(249,100%,72%,1)",
                  "bottom": "#6f57ff"
                },
                "bgOverlay": {
                  "top": "hsla(248,65%,63%,1)",
                  "bottom": "#614eda"
                },
                "text": "#ffffff"
              },
              "outline": {
                "text": "#4969ed",
                "border": "rgba(73,105,237,0.3)",
                "hover": {
                  "text": "#3355e0",
                  "border": "rgba(51,85,224,0.5)"
                },
                "focus": {
                  "border": "#4969ed",
                  "borderInset": "rgba(73,105,237,0.5)"
                }
              },
              "dark": {
                "text": "#ffffff",
                "border": "rgba(255,255,255,0.3)",
                "hover": {
                  "text": "#ffffff",
                  "border": "rgba(255,255,255,0.5)"
                },
                "focus": {
                  "border": "#ffffff",
                  "borderInset": "rgba(255,255,255,0.5)"
                }
              }
            }
          },
          "avatar": {
            "bg": "#ffffff",
            "border": "rgba(27,31,36,0.15)",
            "stackFade": "#afb8c1",
            "stackFadeMore": "#d0d7de"
          },
          "header": {
            "text": "rgba(255,255,255,0.7)",
            "bg": "#24292f",
            "logo": "#ffffff"
          },
          "headerSearch": {
            "bg": "#24292f",
            "border": "#57606a"
          },
          "ansi": {
            "black": "#24292f",
            "blackBright": "#57606a",
            "white": "#6e7781",
            "whiteBright": "#8c959f",
            "gray": "#6e7781",
            "red": "#ac5e00",
            "redBright": "#8b4600",
            "green": "#054da9",
            "greenBright": "#0566d5",
            "yellow": "#4d2d00",
            "yellowBright": "#633c01",
            "blue": "#0969da",
            "blueBright": "#218bff",
            "magenta": "#8250df",
            "magentaBright": "#a475f9",
            "cyan": "#1b7c83",
            "cyanBright": "#3192aa"
          },
          "btn": {
            "text": "#24292f",
            "bg": "#f6f8fa",
            "border": "rgba(27,31,36,0.15)",
            "hoverBg": "#f3f4f6",
            "hoverBorder": "rgba(27,31,36,0.15)",
            "activeBg": "hsla(220,14%,93%,1)",
            "activeBorder": "rgba(27,31,36,0.15)",
            "selectedBg": "hsla(220,14%,94%,1)",
            "focusBg": "#f6f8fa",
            "focusBorder": "rgba(27,31,36,0.15)",
            "counterBg": "rgba(27,31,36,0.08)",
            "primary": {
              "text": "#ffffff",
              "bg": "#0088ff",
              "border": "rgba(27,31,36,0.15)",
              "hoverBg": "#0566d5",
              "hoverBorder": "rgba(27,31,36,0.15)",
              "selectedBg": "hsla(212,95%,41%,1)",
              "disabledText": "rgba(255,255,255,0.8)",
              "disabledBg": "#65ccff",
              "disabledBorder": "rgba(27,31,36,0.15)",
              "focusBg": "#0088ff",
              "focusBorder": "rgba(27,31,36,0.15)",
              "icon": "rgba(255,255,255,0.8)",
              "counterBg": "rgba(255,255,255,0.2)"
            },
            "outline": {
              "text": "#0969da",
              "hoverText": "#ffffff",
              "hoverBg": "#0969da",
              "hoverBorder": "rgba(27,31,36,0.15)",
              "hoverCounterBg": "rgba(255,255,255,0.2)",
              "selectedText": "#ffffff",
              "selectedBg": "hsla(212,92%,42%,1)",
              "selectedBorder": "rgba(27,31,36,0.15)",
              "disabledText": "rgba(9,105,218,0.5)",
              "disabledBg": "#f6f8fa",
              "disabledCounterBg": "rgba(9,105,218,0.05)",
              "focusBorder": "rgba(27,31,36,0.15)",
              "counterBg": "rgba(9,105,218,0.1)"
            },
            "danger": {
              "text": "#ac5e00",
              "hoverText": "#ffffff",
              "hoverBg": "#8b4600",
              "hoverBorder": "rgba(27,31,36,0.15)",
              "hoverCounterBg": "rgba(255,255,255,0.2)",
              "selectedText": "#ffffff",
              "selectedBg": "hsla(33,100%,31%,1)",
              "selectedBorder": "rgba(27,31,36,0.15)",
              "disabledText": "rgba(172,94,0,0.5)",
              "disabledBg": "#f6f8fa",
              "disabledCounterBg": "rgba(172,94,0,0.05)",
              "focusBorder": "rgba(27,31,36,0.15)",
              "counterBg": "rgba(172,94,0,0.1)",
              "icon": "#ac5e00",
              "hoverIcon": "#ffffff"
            }
          },
          "fg": {
            "default": "#24292f",
            "muted": "#57606a",
            "subtle": "#6e7781",
            "onEmphasis": "#ffffff"
          },
          "canvas": {
            "default": "#ffffff",
            "overlay": "#ffffff",
            "inset": "#f6f8fa",
            "subtle": "#f6f8fa"
          },
          "neutral": {
            "emphasisPlus": "#24292f",
            "emphasis": "#6e7781",
            "muted": "rgba(175,184,193,0.2)",
            "subtle": "rgba(234,238,242,0.5)"
          },
          "accent": {
            "fg": "#0969da",
            "emphasis": "#0969da",
            "muted": "rgba(84,174,255,0.4)",
            "subtle": "#ddf4ff"
          },
          "success": {
            "fg": "#0566d5",
            "emphasis": "#0088ff",
            "muted": "rgba(53,173,255,0.4)",
            "subtle": "#c0f6ff"
          },
          "attention": {
            "fg": "#9a6700",
            "emphasis": "#bf8700",
            "muted": "rgba(212,167,44,0.4)",
            "subtle": "#fff8c5"
          },
          "severe": {
            "fg": "#bc4c00",
            "emphasis": "#bc4c00",
            "muted": "rgba(251,143,68,0.4)",
            "subtle": "#fff1e5"
          },
          "danger": {
            "fg": "#ac5e00",
            "emphasis": "#ac5e00",
            "muted": "rgba(231,161,0,0.4)",
            "subtle": "#fefe48"
          },
          "done": {
            "fg": "#8250df",
            "emphasis": "#8250df",
            "muted": "rgba(194,151,255,0.4)",
            "subtle": "#fbefff"
          },
          "sponsors": {
            "fg": "#bf3989",
            "emphasis": "#bf3989",
            "muted": "rgba(255,128,200,0.4)",
            "subtle": "#ffeff7"
          },
          "primer": {
            "canvas": {
              "backdrop": "rgba(27,31,36,0.5)",
              "sticky": "rgba(255,255,255,0.95)"
            },
            "border": {
              "active": "#FD8C73",
              "contrast": "rgba(27,31,36,0.1)"
            }
          }
        },
        "shadows": {
          "shadow": {
            "highlight": "inset 0 1px 0 rgba(255,255,255,0.25)",
            "inset": "inset 0 1px 0 rgba(208,215,222,0.2)",
            "small": "0 1px 0 rgba(27,31,36,0.04)",
            "medium": "0 3px 6px rgba(140,149,159,0.15)",
            "large": "0 8px 24px rgba(140,149,159,0.2)",
            "extraLarge": "0 12px 28px rgba(140,149,159,0.3)"
          },
          "state": {
            "focus": {
              "shadow": "0 0 0 3px rgba(9,105,218,0.3)"
            }
          },
          "autocomplete": {
            "shadow": "0 3px 6px rgba(140,149,159,0.15)"
          },
          "dropdown": {
            "shadow": "0 8px 24px rgba(140,149,159,0.2)"
          },
          "input": {
            "shadow": "inset 0 1px 0 rgba(208,215,222,0.2)"
          },
          "toast": {
            "shadow": "0 8px 24px rgba(140,149,159,0.2)"
          },
          "selectMenu": {
            "shadow": "0 8px 24px rgba(140,149,159,0.2)"
          },
          "avatar": {
            "childShadow": "-2px -2px 0 rgba(255,255,255,0.8)"
          },
          "overlay": {
            "shadow": "0 1px 3px rgba(27,31,36,0.12), 0 8px 24px rgba(66,74,83,0.12)"
          },
          "btn": {
            "shadow": "0 1px 0 rgba(27,31,36,0.04)",
            "insetShadow": "inset 0 1px 0 rgba(255,255,255,0.25)",
            "focusShadow": "0 0 0 3px rgba(9,105,218,0.3)",
            "shadowActive": "inset 0 0.15em 0.3em rgba(27,31,36,0.15)",
            "shadowInputFocus": "0 0 0 0.2em rgba(9,105,218,0.3)",
            "primary": {
              "shadow": "0 1px 0 rgba(27,31,36,0.1)",
              "insetShadow": "inset 0 1px 0 rgba(255,255,255,0.03)",
              "selectedShadow": "inset 0 1px 0 rgba(0,31,80,0.2)",
              "focusShadow": "0 0 0 3px rgba(0,136,255,0.4)"
            },
            "outline": {
              "hoverShadow": "0 1px 0 rgba(27,31,36,0.1)",
              "hoverInsetShadow": "inset 0 1px 0 rgba(255,255,255,0.03)",
              "selectedShadow": "inset 0 1px 0 rgba(0,33,85,0.2)",
              "focusShadow": "0 0 0 3px rgba(5,80,174,0.4)"
            },
            "danger": {
              "hoverShadow": "0 1px 0 rgba(27,31,36,0.1)",
              "hoverInsetShadow": "inset 0 1px 0 rgba(255,255,255,0.03)",
              "selectedShadow": "inset 0 1px 0 rgba(47,41,0,0.2)",
              "focusShadow": "0 0 0 3px rgba(139,70,0,0.4)"
            }
          },
          "primer": {
            "shadow": {
              "highlight": "inset 0 1px 0 rgba(255,255,255,0.25)",
              "inset": "inset 0 1px 0 rgba(208,215,222,0.2)",
              "focus": "0 0 0 3px rgba(9,105,218,0.3)"
            }
          }
        }
      },
      "dark": {
        "colors": {
          "auto": {
            "black": "#f0f6fc",
            "white": "#010409",
            "gray": ["#0d1117", "#161b22", "#21262d", "#30363d", "#484f58", "#6e7681", "#8b949e", "#b1bac4", "#c9d1d9", "#f0f6fc"],
            "blue": ["#051d4d", "#0c2d6b", "#0d419d", "#1158c7", "#1f6feb", "#388bfd", "#58a6ff", "#79c0ff", "#a5d6ff", "#cae8ff"],
            "green": ["#04260f", "#033a16", "#0f5323", "#196c2e", "#238636", "#2ea043", "#3fb950", "#56d364", "#7ee787", "#aff5b4"],
            "yellow": ["#341a00", "#4b2900", "#693e00", "#845306", "#9e6a03", "#bb8009", "#d29922", "#e3b341", "#f2cc60", "#f8e3a1"],
            "orange": ["#3d1300", "#5a1e02", "#762d0a", "#9b4215", "#bd561d", "#db6d28", "#f0883e", "#ffa657", "#ffc680", "#ffdfb6"],
            "red": ["#490202", "#67060c", "#8e1519", "#b62324", "#da3633", "#f85149", "#ff7b72", "#ffa198", "#ffc1ba", "#ffdcd7"],
            "purple": ["#271052", "#3c1e70", "#553098", "#6e40c9", "#8957e5", "#a371f7", "#bc8cff", "#d2a8ff", "#e2c5ff", "#eddeff"],
            "pink": ["#42062a", "#5e103e", "#7d2457", "#9e3670", "#bf4b8a", "#db61a2", "#f778ba", "#ff9bce", "#ffbedd", "#ffdaec"]
          },
          "text": {
            "primary": "#c9d1d9",
            "secondary": "#8b949e",
            "tertiary": "#8b949e",
            "placeholder": "#484f58",
            "disabled": "#8b949e",
            "inverse": "#f0f6fc",
            "link": "#58a6ff",
            "danger": "#f85149",
            "success": "#3fb950",
            "warning": "#d29922",
            "white": "#f0f6fc"
          },
          "icon": {
            "primary": "#c9d1d9",
            "secondary": "#8b949e",
            "tertiary": "#8b949e",
            "info": "#58a6ff",
            "danger": "#f85149",
            "success": "#3fb950",
            "warning": "#d29922"
          },
          "border": {
            "primary": "#30363d",
            "secondary": "#21262d",
            "tertiary": "#30363d",
            "overlay": "#30363d",
            "inverse": "#f0f6fc",
            "info": "#1f6feb",
            "danger": "#da3633",
            "success": "#238636",
            "warning": "#9e6a03",
            "default": "#30363d",
            "muted": "#21262d",
            "subtle": "rgba(240,246,252,0.1)"
          },
          "bg": {
            "canvas": "#0d1117",
            "canvasMobile": "rgba(0,0,0,0)",
            "canvasInverse": "#6e7681",
            "canvasInset": "#010409",
            "primary": "#0d1117",
            "secondary": "#161b22",
            "tertiary": "#161b22",
            "overlay": "#161b22",
            "backdrop": "rgba(1,4,9,0.8)",
            "info": "rgba(56,139,253,0.15)",
            "infoInverse": "#1f6feb",
            "danger": "rgba(248,81,73,0.15)",
            "dangerInverse": "#da3633",
            "success": "rgba(46,160,67,0.15)",
            "successInverse": "#238636",
            "warning": "rgba(187,128,9,0.15)",
            "warningInverse": "#9e6a03"
          },
          "state": {
            "hover": {
              "primaryBg": "#1f6feb",
              "primaryBorder": "#1f6feb",
              "primaryText": "#f0f6fc",
              "primaryIcon": "#f0f6fc",
              "secondaryBg": "rgba(110,118,129,0.1)",
              "secondaryBorder": "rgba(110,118,129,0.1)"
            },
            "selected": {
              "primaryBg": "#1f6feb",
              "primaryBorder": "#1f6feb",
              "primaryText": "#f0f6fc",
              "primaryIcon": "#f0f6fc"
            },
            "focus": {
              "border": "#1f6feb"
            }
          },
          "fade": {
            "fg10": "rgba(240,246,252,0.1)",
            "fg15": "rgba(240,246,252,0.15)",
            "fg30": "rgba(240,246,252,0.3)",
            "fg50": "rgba(240,246,252,0.5)",
            "fg70": "rgba(240,246,252,0.7)",
            "fg85": "rgba(240,246,252,0.85)",
            "black10": "rgba(1,4,9,0.1)",
            "black15": "rgba(1,4,9,0.15)",
            "black30": "rgba(1,4,9,0.3)",
            "black50": "rgba(1,4,9,0.5)",
            "black70": "rgba(1,4,9,0.7)",
            "black85": "rgba(1,4,9,0.85)",
            "white10": "rgba(240,246,252,0.1)",
            "white15": "rgba(240,246,252,0.15)",
            "white30": "rgba(240,246,252,0.3)",
            "white50": "rgba(240,246,252,0.5)",
            "white70": "rgba(240,246,252,0.7)",
            "white85": "rgba(240,246,252,0.85)"
          },
          "alert": {
            "info": {
              "text": "#c9d1d9",
              "icon": "#58a6ff",
              "bg": "rgba(56,139,253,0.15)",
              "border": "rgba(56,139,253,0.4)"
            },
            "warn": {
              "text": "#c9d1d9",
              "icon": "#d29922",
              "bg": "rgba(187,128,9,0.15)",
              "border": "rgba(187,128,9,0.4)"
            },
            "error": {
              "text": "#c9d1d9",
              "icon": "#f85149",
              "bg": "rgba(248,81,73,0.15)",
              "border": "rgba(248,81,73,0.4)"
            },
            "success": {
              "text": "#c9d1d9",
              "icon": "#3fb950",
              "bg": "rgba(46,160,67,0.15)",
              "border": "rgba(46,160,67,0.4)"
            }
          },
          "autocomplete": {
            "rowBorder": "#21262d"
          },
          "blankslate": {
            "icon": "#8b949e"
          },
          "counter": {
            "text": "#c9d1d9",
            "bg": "rgba(110,118,129,0.4)",
            "primary": {
              "text": "#f0f6fc",
              "bg": "#6e7681"
            },
            "secondary": {
              "text": "#8b949e",
              "bg": "rgba(110,118,129,0.1)"
            }
          },
          "box": {
            "blueBorder": "rgba(56,139,253,0.4)",
            "rowYellowBg": "rgba(187,128,9,0.15)",
            "rowBlueBg": "rgba(56,139,253,0.15)",
            "headerBlueBg": "rgba(56,139,253,0.15)",
            "headerBlueBorder": "rgba(56,139,253,0.4)",
            "borderInfo": "rgba(56,139,253,0.4)",
            "bgInfo": "rgba(56,139,253,0.15)",
            "borderWarning": "rgba(187,128,9,0.4)",
            "bgWarning": "rgba(187,128,9,0.15)"
          },
          "branchName": {
            "text": "#8b949e",
            "icon": "#8b949e",
            "bg": "rgba(56,139,253,0.15)",
            "link": {
              "text": "#58a6ff",
              "icon": "#58a6ff",
              "bg": "rgba(56,139,253,0.15)"
            }
          },
          "markdown": {
            "codeBg": "rgba(110,118,129,0.4)",
            "frameBorder": "#30363d",
            "blockquoteBorder": "#30363d",
            "tableBorder": "#30363d",
            "tableTrBorder": "#21262d"
          },
          "filterItem": {
            "barBg": "rgba(110,118,129,0.1)"
          },
          "hiddenTextExpander": {
            "bg": "rgba(110,118,129,0.4)",
            "bgHover": "rgba(56,139,253,0.4)"
          },
          "dragAndDrop": {
            "border": "#30363d"
          },
          "uploadEnabled": {
            "border": "#30363d",
            "borderFocused": "#1f6feb"
          },
          "previewableCommentForm": {
            "border": "#30363d"
          },
          "verifiedBadge": {
            "text": "#3fb950",
            "bg": "#0d1117",
            "border": "#30363d"
          },
          "socialCount": {
            "bg": "#0d1117"
          },
          "tooltip": {
            "text": "#f0f6fc",
            "bg": "#6e7681"
          },
          "filesExplorerIcon": "#58a6ff",
          "hlAuthorBg": "rgba(56,139,253,0.15)",
          "hlAuthorBorder": "rgba(56,139,253,0.4)",
          "logoSubdued": "rgba(110,118,129,0.4)",
          "discussionBorder": "rgba(46,160,67,0.4)",
          "discussionBgSuccess": "#238636",
          "actionsWorkflowTableStickyBg": "rgba(13,17,23,0.95)",
          "repoLanguageColorBorder": "rgba(240,246,252,0.2)",
          "codeSelectionBg": "rgba(56,139,253,0.4)",
          "highlight": {
            "text": "#c9d1d9",
            "bg": "rgba(187,128,9,0.15)"
          },
          "blob": {
            "lineHighlightBg": "rgba(187,128,9,0.15)",
            "lineHighlightBorder": "rgba(187,128,9,0.4)"
          },
          "topicTag": {
            "text": "#58a6ff",
            "bg": "rgba(56,139,253,0.15)",
            "hoverBg": "#1f6feb",
            "activeBg": "rgba(56,139,253,0.15)",
            "border": "rgba(0,0,0,0)"
          },
          "footerInvertocat": {
            "octicon": "#484f58",
            "octiconHover": "#8b949e"
          },
          "label": {
            "border": "#30363d",
            "primary": {
              "text": "#c9d1d9",
              "border": "#6e7681"
            },
            "secondary": {
              "text": "#8b949e",
              "border": "#30363d"
            },
            "info": {
              "text": "#58a6ff",
              "border": "#1f6feb"
            },
            "success": {
              "text": "#3fb950",
              "border": "#238636"
            },
            "warning": {
              "text": "#d29922",
              "border": "#9e6a03"
            },
            "danger": {
              "text": "#f85149",
              "border": "#da3633"
            },
            "orange": {
              "text": "#db6d28",
              "border": "#bd561d"
            }
          },
          "input": {
            "bg": "#0d1117",
            "contrastBg": "#010409",
            "border": "#30363d",
            "disabledBorder": "#30363d",
            "warningBorder": "#9e6a03",
            "errorBorder": "#da3633",
            "tooltip": {
              "success": {
                "text": "#c9d1d9",
                "bg": "rgba(46,160,67,0.15)",
                "border": "rgba(46,160,67,0.4)"
              },
              "warning": {
                "text": "#c9d1d9",
                "bg": "rgba(187,128,9,0.15)",
                "border": "rgba(187,128,9,0.4)"
              },
              "error": {
                "text": "#c9d1d9",
                "bg": "rgba(248,81,73,0.15)",
                "border": "rgba(248,81,73,0.4)"
              }
            },
            "disabledBg": "rgba(110,118,129,0)"
          },
          "toast": {
            "text": "#c9d1d9",
            "bg": "#0d1117",
            "border": "#30363d",
            "icon": "#f0f6fc",
            "iconBg": "#1f6feb",
            "iconBorder": "rgba(0,0,0,0)",
            "success": {
              "text": "#c9d1d9",
              "border": "#30363d",
              "icon": "#f0f6fc",
              "iconBg": "#238636",
              "iconBorder": "rgba(0,0,0,0)"
            },
            "warning": {
              "text": "#c9d1d9",
              "border": "#30363d",
              "icon": "#c9d1d9",
              "iconBg": "#9e6a03",
              "iconBorder": "rgba(0,0,0,0)"
            },
            "danger": {
              "text": "#c9d1d9",
              "border": "#30363d",
              "icon": "#f0f6fc",
              "iconBg": "#da3633",
              "iconBorder": "rgba(0,0,0,0)"
            },
            "loading": {
              "text": "#c9d1d9",
              "border": "#30363d",
              "icon": "#f0f6fc",
              "iconBg": "#6e7681",
              "iconBorder": "rgba(0,0,0,0)"
            }
          },
          "timeline": {
            "text": "#8b949e",
            "badgeSuccessBorder": "rgba(0,0,0,0)",
            "targetBadgeBorder": "#1f6feb",
            "targetBadgeShadow": "rgba(56,139,253,0.4)",
            "badgeBg": "#21262d"
          },
          "diffstat": {
            "neutralBg": "rgba(110,118,129,0.4)",
            "neutralBorder": "rgba(240,246,252,0.1)",
            "deletionBorder": "rgba(240,246,252,0.1)",
            "additionBorder": "rgba(240,246,252,0.1)",
            "deletionBg": "#da3633",
            "additionBg": "#3fb950"
          },
          "diff": {
            "addition": {
              "text": "#c9d1d9",
              "bg": "rgba(46,160,67,0.15)",
              "border": "rgba(46,160,67,0.4)"
            },
            "deletion": {
              "text": "#c9d1d9",
              "bg": "rgba(248,81,73,0.15)",
              "border": "rgba(248,81,73,0.4)"
            },
            "change": {
              "text": "#d29922",
              "bg": "rgba(187,128,9,0.15)",
              "border": "rgba(187,128,9,0.4)"
            }
          },
          "mergeBox": {
            "successIconBg": "#238636",
            "successIconText": "#f0f6fc",
            "successIconBorder": "rgba(0,0,0,0)",
            "successIndicatorBg": "#238636",
            "successIndicatorBorder": "rgba(0,0,0,0)",
            "mergedIconBg": "#8957e5",
            "mergedIconText": "#f0f6fc",
            "mergedIconBorder": "rgba(0,0,0,0)",
            "mergedBoxBorder": "#8957e5",
            "neutralIconBg": "#6e7681",
            "neutralIconText": "#f0f6fc",
            "neutralIconBorder": "rgba(0,0,0,0)",
            "neutralIndicatorBg": "#6e7681",
            "neutralIndicatorBorder": "rgba(0,0,0,0)",
            "warningIconBg": "#9e6a03",
            "warningIconText": "#f0f6fc",
            "warningIconBorder": "rgba(0,0,0,0)",
            "warningBoxBorder": "#9e6a03",
            "warningMergeHighlight": "rgba(0,0,0,0)",
            "errorIconBg": "#da3633",
            "errorIconText": "#f0f6fc",
            "errorIconBorder": "rgba(0,0,0,0)",
            "errorIndicatorBg": "#da3633",
            "errorIndicatorBorder": "rgba(0,0,0,0)"
          },
          "underlinenav": {
            "border": "rgba(0,0,0,0)",
            "borderHover": "rgba(110,118,129,0.4)",
            "borderActive": "#F78166",
            "text": "#c9d1d9",
            "textHover": "#c9d1d9",
            "textActive": "#c9d1d9",
            "icon": "#484f58",
            "iconHover": "#484f58",
            "iconActive": "#c9d1d9",
            "counterText": "#c9d1d9",
            "counterBg": "rgba(110,118,129,0.4)"
          },
          "selectMenu": {
            "borderSecondary": "#21262d",
            "backdropBg": "rgba(1,4,9,0.8)",
            "backdropBorder": "#484f58",
            "tapHighlight": "rgba(48,54,61,0.5)",
            "tapFocusBg": "#0c2d6b"
          },
          "sidenav": {
            "borderActive": "#F78166",
            "selectedBg": "#21262d"
          },
          "menu": {
            "headingText": "#c9d1d9",
            "borderActive": "#F78166",
            "bgActive": "#161b22"
          },
          "project": {
            "cardBg": "#161b22",
            "headerBg": "#0d1117",
            "sidebarBg": "#161b22",
            "gradientIn": "#161b22",
            "gradientOut": "rgba(22,27,34,0)"
          },
          "prState": {
            "draft": {
              "text": "#f0f6fc",
              "bg": "#6e7681",
              "border": "rgba(0,0,0,0)"
            },
            "open": {
              "text": "#f0f6fc",
              "bg": "#238636",
              "border": "rgba(0,0,0,0)"
            },
            "merged": {
              "text": "#f0f6fc",
              "bg": "#8957e5",
              "border": "rgba(0,0,0,0)"
            },
            "closed": {
              "text": "#f0f6fc",
              "bg": "#da3633",
              "border": "rgba(0,0,0,0)"
            }
          },
          "diffBlob": {
            "numText": "#484f58",
            "numHoverText": "#c9d1d9",
            "addition": {
              "numHoverText": "#c9d1d9",
              "numText": "#c9d1d9",
              "fg": "#c9d1d9",
              "numBg": "rgba(63,185,80,0.3)",
              "lineBg": "rgba(46,160,67,0.15)",
              "wordBg": "rgba(46,160,67,0.4)"
            },
            "deletion": {
              "numHoverText": "#c9d1d9",
              "numText": "#c9d1d9",
              "fg": "#c9d1d9",
              "numBg": "rgba(248,81,73,0.3)",
              "lineBg": "rgba(248,81,73,0.15)",
              "wordBg": "rgba(248,81,73,0.4)"
            },
            "hunk": {
              "text": "#8b949e",
              "numBg": "rgba(56,139,253,0.4)",
              "lineBg": "rgba(56,139,253,0.15)"
            },
            "emptyBlockBg": "rgba(110,118,129,0.1)",
            "selectedLineHighlightBg": "rgba(187,128,9,0.15)",
            "selectedLineHighlightBorder": "rgba(187,128,9,0.4)",
            "expander": {
              "hoverIcon": "#f0f6fc",
              "hoverBg": "#1f6feb",
              "icon": "#8b949e"
            },
            "commentButton": {
              "icon": "#f0f6fc",
              "bg": "#1f6feb",
              "gradientBg": "rgba(0,0,0,0)"
            }
          },
          "globalNav": {
            "logo": "#f0f6fc",
            "bg": "#161b22",
            "text": "#c9d1d9",
            "icon": "#c9d1d9",
            "inputBg": "#0d1117",
            "inputBorder": "#21262d",
            "inputIcon": "#21262d",
            "inputPlaceholder": "#484f58"
          },
          "introShelf": {
            "gradientLeft": "rgba(56,139,253,0.15)",
            "gradientRight": "rgba(46,160,67,0.15)",
            "gradientIn": "#0d1117",
            "gradientOut": "rgba(240,246,252,0)"
          },
          "canvasDefaultTransparent": "rgba(13,17,23,0)",
          "marketingIcon": {
            "primary": "#79c0ff",
            "secondary": "#1f6feb"
          },
          "searchKeyword": {
            "hl": "rgba(210,153,34,0.4)"
          },
          "prettylights": {
            "syntax": {
              "comment": "#8b949e",
              "constant": "#79c0ff",
              "entity": "#d2a8ff",
              "storageModifierImport": "#c9d1d9",
              "entityTag": "#7ee787",
              "keyword": "#ff7b72",
              "string": "#a5d6ff",
              "variable": "#ffa657",
              "brackethighlighterUnmatched": "#f85149",
              "invalidIllegalText": "#f0f6fc",
              "invalidIllegalBg": "#8e1519",
              "carriageReturnText": "#f0f6fc",
              "carriageReturnBg": "#b62324",
              "stringRegexp": "#7ee787",
              "markupList": "#f2cc60",
              "markupHeading": "#1f6feb",
              "markupItalic": "#c9d1d9",
              "markupBold": "#c9d1d9",
              "markupDeletedText": "#ffdcd7",
              "markupDeletedBg": "#67060c",
              "markupInsertedText": "#aff5b4",
              "markupInsertedBg": "#033a16",
              "markupChangedText": "#ffdfb6",
              "markupChangedBg": "#5a1e02",
              "markupIgnoredText": "#c9d1d9",
              "markupIgnoredBg": "#1158c7",
              "metaDiffRange": "#d2a8ff",
              "brackethighlighterAngle": "#8b949e",
              "sublimelinterGutterMark": "#484f58",
              "constantOtherReferenceLink": "#a5d6ff"
            }
          },
          "codemirror": {
            "text": "#c9d1d9",
            "bg": "#0d1117",
            "guttersBg": "#0d1117",
            "guttermarkerText": "#0d1117",
            "guttermarkerSubtleText": "#484f58",
            "linenumberText": "#8b949e",
            "cursor": "#c9d1d9",
            "selectionBg": "rgba(56,139,253,0.4)",
            "activelineBg": "rgba(110,118,129,0.1)",
            "matchingbracketText": "#c9d1d9",
            "linesBg": "#0d1117",
            "syntax": {
              "comment": "#8b949e",
              "constant": "#79c0ff",
              "entity": "#d2a8ff",
              "keyword": "#ff7b72",
              "storage": "#ff7b72",
              "string": "#a5d6ff",
              "support": "#79c0ff",
              "variable": "#ffa657"
            }
          },
          "checks": {
            "bg": "#010409",
            "textPrimary": "#c9d1d9",
            "textSecondary": "#8b949e",
            "textLink": "#58a6ff",
            "btnIcon": "#8b949e",
            "btnHoverIcon": "#c9d1d9",
            "btnHoverBg": "rgba(110,118,129,0.1)",
            "inputText": "#8b949e",
            "inputPlaceholderText": "#484f58",
            "inputFocusText": "#c9d1d9",
            "inputBg": "#161b22",
            "donutError": "#f85149",
            "donutPending": "#d29922",
            "donutSuccess": "#2ea043",
            "donutNeutral": "#8b949e",
            "dropdownText": "#c9d1d9",
            "dropdownBg": "#161b22",
            "dropdownBorder": "#30363d",
            "dropdownShadow": "rgba(1,4,9,0.3)",
            "dropdownHoverText": "#c9d1d9",
            "dropdownHoverBg": "rgba(110,118,129,0.1)",
            "dropdownBtnHoverText": "#c9d1d9",
            "dropdownBtnHoverBg": "rgba(110,118,129,0.1)",
            "scrollbarThumbBg": "rgba(110,118,129,0.4)",
            "headerLabelText": "#8b949e",
            "headerLabelOpenText": "#c9d1d9",
            "headerBorder": "#21262d",
            "headerIcon": "#8b949e",
            "lineText": "#8b949e",
            "lineNumText": "#484f58",
            "lineTimestampText": "#484f58",
            "lineHoverBg": "rgba(110,118,129,0.1)",
            "lineSelectedBg": "rgba(56,139,253,0.15)",
            "lineSelectedNumText": "#58a6ff",
            "lineDtFmText": "#f0f6fc",
            "lineDtFmBg": "#9e6a03",
            "gateBg": "rgba(187,128,9,0.15)",
            "gateText": "#8b949e",
            "gateWaitingText": "#d29922",
            "stepHeaderOpenBg": "#161b22",
            "stepErrorText": "#f85149",
            "stepWarningText": "#d29922",
            "loglineText": "#8b949e",
            "loglineNumText": "#484f58",
            "loglineDebugText": "#a371f7",
            "loglineErrorText": "#8b949e",
            "loglineErrorNumText": "#484f58",
            "loglineErrorBg": "rgba(248,81,73,0.15)",
            "loglineWarningText": "#8b949e",
            "loglineWarningNumText": "#d29922",
            "loglineWarningBg": "rgba(187,128,9,0.15)",
            "loglineCommandText": "#58a6ff",
            "loglineSectionText": "#3fb950",
            "ansi": {
              "black": "#0d1117",
              "blackBright": "#161b22",
              "white": "#b1bac4",
              "whiteBright": "#b1bac4",
              "gray": "#6e7681",
              "red": "#ff7b72",
              "redBright": "#ffa198",
              "green": "#3fb950",
              "greenBright": "#56d364",
              "yellow": "#d29922",
              "yellowBright": "#e3b341",
              "blue": "#58a6ff",
              "blueBright": "#79c0ff",
              "magenta": "#bc8cff",
              "magentaBright": "#d2a8ff",
              "cyan": "#76e3ea",
              "cyanBright": "#b3f0ff"
            }
          },
          "mktg": {
            "success": "rgba(41,147,61,1)",
            "info": "rgba(42,123,243,1)",
            "bgShadeGradient": {
              "top": "rgba(1,4,9,0.065)",
              "bottom": "rgba(1,4,9,0)"
            },
            "btn": {
              "bg": {
                "top": "hsla(228,82%,66%,1)",
                "bottom": "#4969ed"
              },
              "bgOverlay": {
                "top": "hsla(228,74%,59%,1)",
                "bottom": "#3355e0"
              },
              "text": "#f0f6fc",
              "primary": {
                "bg": {
                  "top": "hsla(137,56%,46%,1)",
                  "bottom": "#2ea44f"
                },
                "bgOverlay": {
                  "top": "hsla(134,60%,38%,1)",
                  "bottom": "#22863a"
                },
                "text": "#f0f6fc"
              },
              "enterprise": {
                "bg": {
                  "top": "hsla(249,100%,72%,1)",
                  "bottom": "#6f57ff"
                },
                "bgOverlay": {
                  "top": "hsla(248,65%,63%,1)",
                  "bottom": "#614eda"
                },
                "text": "#f0f6fc"
              },
              "outline": {
                "text": "#f0f6fc",
                "border": "rgba(240,246,252,0.3)",
                "hover": {
                  "text": "#f0f6fc",
                  "border": "rgba(240,246,252,0.5)"
                },
                "focus": {
                  "border": "#f0f6fc",
                  "borderInset": "rgba(240,246,252,0.5)"
                }
              },
              "dark": {
                "text": "#f0f6fc",
                "border": "rgba(240,246,252,0.3)",
                "hover": {
                  "text": "#f0f6fc",
                  "border": "rgba(240,246,252,0.5)"
                },
                "focus": {
                  "border": "#f0f6fc",
                  "borderInset": "rgba(240,246,252,0.5)"
                }
              }
            }
          },
          "avatar": {
            "bg": "rgba(240,246,252,0.1)",
            "border": "rgba(240,246,252,0.1)",
            "stackFade": "#30363d",
            "stackFadeMore": "#21262d"
          },
          "header": {
            "text": "rgba(240,246,252,0.7)",
            "bg": "#161b22",
            "logo": "#f0f6fc"
          },
          "headerSearch": {
            "bg": "#0d1117",
            "border": "#30363d"
          },
          "ansi": {
            "black": "#484f58",
            "blackBright": "#6e7681",
            "white": "#b1bac4",
            "whiteBright": "#f0f6fc",
            "gray": "#6e7681",
            "red": "#ff7b72",
            "redBright": "#ffa198",
            "green": "#3fb950",
            "greenBright": "#56d364",
            "yellow": "#d29922",
            "yellowBright": "#e3b341",
            "blue": "#58a6ff",
            "blueBright": "#79c0ff",
            "magenta": "#bc8cff",
            "magentaBright": "#d2a8ff",
            "cyan": "#39c5cf",
            "cyanBright": "#56d4dd"
          },
          "btn": {
            "text": "#c9d1d9",
            "bg": "#21262d",
            "border": "rgba(240,246,252,0.1)",
            "hoverBg": "#30363d",
            "hoverBorder": "#8b949e",
            "activeBg": "hsla(212,12%,18%,1)",
            "activeBorder": "#6e7681",
            "selectedBg": "#161b22",
            "focusBg": "#21262d",
            "focusBorder": "#8b949e",
            "counterBg": "#30363d",
            "primary": {
              "text": "#ffffff",
              "bg": "#238636",
              "border": "rgba(240,246,252,0.1)",
              "hoverBg": "#2ea043",
              "hoverBorder": "rgba(240,246,252,0.1)",
              "selectedBg": "#238636",
              "disabledText": "rgba(240,246,252,0.5)",
              "disabledBg": "rgba(35,134,54,0.6)",
              "disabledBorder": "rgba(240,246,252,0.1)",
              "focusBg": "#238636",
              "focusBorder": "rgba(240,246,252,0.1)",
              "icon": "#f0f6fc",
              "counterBg": "rgba(240,246,252,0.2)"
            },
            "outline": {
              "text": "#58a6ff",
              "hoverText": "#58a6ff",
              "hoverBg": "#30363d",
              "hoverBorder": "rgba(240,246,252,0.1)",
              "hoverCounterBg": "rgba(240,246,252,0.2)",
              "selectedText": "#f0f6fc",
              "selectedBg": "#0d419d",
              "selectedBorder": "rgba(240,246,252,0.1)",
              "disabledText": "rgba(88,166,255,0.5)",
              "disabledBg": "#0d1117",
              "disabledCounterBg": "rgba(31,111,235,0.05)",
              "focusBorder": "rgba(240,246,252,0.1)",
              "counterBg": "rgba(31,111,235,0.1)"
            },
            "danger": {
              "text": "#f85149",
              "hoverText": "#f0f6fc",
              "hoverBg": "#da3633",
              "hoverBorder": "#f85149",
              "hoverIcon": "#f0f6fc",
              "hoverCounterBg": "rgba(255,255,255,0.2)",
              "selectedText": "#ffffff",
              "selectedBg": "#b62324",
              "selectedBorder": "#ff7b72",
              "disabledText": "rgba(248,81,73,0.5)",
              "disabledBg": "#0d1117",
              "disabledCounterBg": "rgba(218,54,51,0.05)",
              "focusBorder": "#f85149",
              "counterBg": "rgba(218,54,51,0.1)",
              "icon": "#f85149"
            }
          },
          "fg": {
            "default": "#c9d1d9",
            "muted": "#8b949e",
            "subtle": "#484f58",
            "onEmphasis": "#f0f6fc"
          },
          "canvas": {
            "default": "#0d1117",
            "overlay": "#161b22",
            "inset": "#010409",
            "subtle": "#161b22"
          },
          "neutral": {
            "emphasisPlus": "#6e7681",
            "emphasis": "#6e7681",
            "muted": "rgba(110,118,129,0.4)",
            "subtle": "rgba(110,118,129,0.1)"
          },
          "accent": {
            "fg": "#58a6ff",
            "emphasis": "#1f6feb",
            "muted": "rgba(56,139,253,0.4)",
            "subtle": "rgba(56,139,253,0.15)"
          },
          "success": {
            "fg": "#3fb950",
            "emphasis": "#238636",
            "muted": "rgba(46,160,67,0.4)",
            "subtle": "rgba(46,160,67,0.15)"
          },
          "attention": {
            "fg": "#d29922",
            "emphasis": "#9e6a03",
            "muted": "rgba(187,128,9,0.4)",
            "subtle": "rgba(187,128,9,0.15)"
          },
          "severe": {
            "fg": "#db6d28",
            "emphasis": "#bd561d",
            "muted": "rgba(219,109,40,0.4)",
            "subtle": "rgba(219,109,40,0.15)"
          },
          "danger": {
            "fg": "#f85149",
            "emphasis": "#da3633",
            "muted": "rgba(248,81,73,0.4)",
            "subtle": "rgba(248,81,73,0.15)"
          },
          "done": {
            "fg": "#a371f7",
            "emphasis": "#8957e5",
            "muted": "rgba(163,113,247,0.4)",
            "subtle": "rgba(163,113,247,0.15)"
          },
          "sponsors": {
            "fg": "#db61a2",
            "emphasis": "#bf4b8a",
            "muted": "rgba(219,97,162,0.4)",
            "subtle": "rgba(219,97,162,0.15)"
          },
          "primer": {
            "canvas": {
              "backdrop": "rgba(1,4,9,0.8)",
              "sticky": "rgba(13,17,23,0.95)"
            },
            "border": {
              "active": "#F78166",
              "contrast": "rgba(240,246,252,0.2)"
            }
          }
        },
        "shadows": {
          "shadow": {
            "highlight": "0 0 transparent",
            "inset": "0 0 transparent",
            "small": "0 0 transparent",
            "medium": "0 3px 6px #010409",
            "large": "0 8px 24px #010409",
            "extraLarge": "0 12px 48px #010409"
          },
          "state": {
            "focus": {
              "shadow": "0 0 0 3px #0c2d6b"
            }
          },
          "autocomplete": {
            "shadow": "0 3px 6px #010409"
          },
          "dropdown": {
            "shadow": "0 8px 24px #010409"
          },
          "input": {
            "shadow": "0 0 transparent"
          },
          "toast": {
            "shadow": "0 8px 24px #010409"
          },
          "selectMenu": {
            "shadow": "0 8px 24px #010409"
          },
          "checks": {
            "inputShadow": "0 0 0 1px (obj) => get_1.default(obj, path)"
          },
          "avatar": {
            "childShadow": "-2px -2px 0 #0d1117"
          },
          "overlay": {
            "shadow": "0 0 0 1px #30363d, 0 16px 32px rgba(1,4,9,0.85)"
          },
          "btn": {
            "shadow": "0 0 transparent",
            "insetShadow": "0 0 transparent",
            "focusShadow": "0 0 0 3px rgba(139,148,158,0.3)",
            "shadowActive": "inset 0 0.15em 0.3em rgba(1,4,9,0.15)",
            "shadowInputFocus": "0 0 0 0.2em rgba(31,111,235,0.3)",
            "primary": {
              "shadow": "0 0 transparent",
              "insetShadow": "0 0 transparent",
              "selectedShadow": "0 0 transparent",
              "focusShadow": "0 0 0 3px rgba(46,164,79,0.4)"
            },
            "outline": {
              "hoverShadow": "0 1px 0 rgba(1,4,9,0.1)",
              "hoverInsetShadow": "inset 0 1px 0 rgba(240,246,252,0.03)",
              "selectedShadow": "0 0 transparent",
              "focusShadow": "0 0 0 3px rgba(17,88,199,0.4)"
            },
            "danger": {
              "hoverShadow": "0 0 transparent",
              "hoverInsetShadow": "0 0 transparent",
              "selectedShadow": "0 0 transparent",
              "focusShadow": "0 0 0 3px rgba(248,81,73,0.4)"
            }
          },
          "primer": {
            "shadow": {
              "highlight": "0 0 transparent",
              "inset": "0 0 transparent",
              "focus": "0 0 0 3px #0c2d6b"
            }
          }
        }
      },
      "dark_dimmed": {
        "colors": {
          "auto": {
            "black": "#cdd9e5",
            "white": "#1c2128",
            "gray": ["#22272e", "#2d333b", "#373e47", "#444c56", "#545d68", "#636e7b", "#768390", "#909dab", "#adbac7", "#cdd9e5"],
            "blue": ["#0f2d5c", "#143d79", "#1b4b91", "#255ab2", "#316dca", "#4184e4", "#539bf5", "#6cb6ff", "#96d0ff", "#c6e6ff"],
            "green": ["#113417", "#1b4721", "#245829", "#2b6a30", "#347d39", "#46954a", "#57ab5a", "#6bc46d", "#8ddb8c", "#b4f1b4"],
            "yellow": ["#452700", "#593600", "#6c4400", "#805400", "#966600", "#ae7c14", "#c69026", "#daaa3f", "#eac55f", "#fbe090"],
            "orange": ["#4d210c", "#682d0f", "#7f3913", "#94471b", "#ae5622", "#cc6b2c", "#e0823d", "#f69d50", "#ffbc6f", "#ffddb0"],
            "red": ["#78191b", "#78191b", "#922323", "#ad2e2c", "#c93c37", "#e5534b", "#f47067", "#ff938a", "#ffb8b0", "#ffd8d3"],
            "purple": ["#352160", "#472c82", "#5936a2", "#6b44bc", "#8256d0", "#986ee2", "#b083f0", "#dcbdfb", "#dcbdfb", "#eedcff"],
            "pink": ["#551639", "#69264a", "#7e325a", "#983b6e", "#ae4c82", "#c96198", "#e275ad", "#fc8dc7", "#ffb3d8", "#ffd7eb"]
          },
          "text": {
            "primary": "#adbac7",
            "secondary": "#768390",
            "tertiary": "#768390",
            "placeholder": "#545d68",
            "disabled": "#768390",
            "inverse": "#cdd9e5",
            "link": "#539bf5",
            "danger": "#e5534b",
            "success": "#57ab5a",
            "warning": "#c69026",
            "white": "#cdd9e5"
          },
          "icon": {
            "primary": "#adbac7",
            "secondary": "#768390",
            "tertiary": "#768390",
            "info": "#539bf5",
            "danger": "#e5534b",
            "success": "#57ab5a",
            "warning": "#c69026"
          },
          "border": {
            "primary": "#444c56",
            "secondary": "#373e47",
            "tertiary": "#444c56",
            "overlay": "#444c56",
            "inverse": "#cdd9e5",
            "info": "#316dca",
            "danger": "#c93c37",
            "success": "#347d39",
            "warning": "#966600",
            "default": "#444c56",
            "muted": "#373e47",
            "subtle": "rgba(205,217,229,0.1)"
          },
          "bg": {
            "canvas": "#22272e",
            "canvasMobile": "rgba(0,0,0,0)",
            "canvasInverse": "#636e7b",
            "canvasInset": "#1c2128",
            "primary": "#22272e",
            "secondary": "#2d333b",
            "tertiary": "#2d333b",
            "overlay": "#2d333b",
            "backdrop": "rgba(28,33,40,0.8)",
            "info": "rgba(65,132,228,0.15)",
            "infoInverse": "#316dca",
            "danger": "rgba(229,83,75,0.15)",
            "dangerInverse": "#c93c37",
            "success": "rgba(70,149,74,0.15)",
            "successInverse": "#347d39",
            "warning": "rgba(174,124,20,0.15)",
            "warningInverse": "#966600"
          },
          "state": {
            "hover": {
              "primaryBg": "#316dca",
              "primaryBorder": "#316dca",
              "primaryText": "#cdd9e5",
              "primaryIcon": "#cdd9e5",
              "secondaryBg": "rgba(99,110,123,0.1)",
              "secondaryBorder": "rgba(99,110,123,0.1)"
            },
            "selected": {
              "primaryBg": "#316dca",
              "primaryBorder": "#316dca",
              "primaryText": "#cdd9e5",
              "primaryIcon": "#cdd9e5"
            },
            "focus": {
              "border": "#316dca"
            }
          },
          "fade": {
            "fg10": "rgba(205,217,229,0.1)",
            "fg15": "rgba(205,217,229,0.15)",
            "fg30": "rgba(205,217,229,0.3)",
            "fg50": "rgba(205,217,229,0.5)",
            "fg70": "rgba(205,217,229,0.7)",
            "fg85": "rgba(205,217,229,0.85)",
            "black10": "rgba(28,33,40,0.1)",
            "black15": "rgba(28,33,40,0.15)",
            "black30": "rgba(28,33,40,0.3)",
            "black50": "rgba(28,33,40,0.5)",
            "black70": "rgba(28,33,40,0.7)",
            "black85": "rgba(28,33,40,0.85)",
            "white10": "rgba(205,217,229,0.1)",
            "white15": "rgba(205,217,229,0.15)",
            "white30": "rgba(205,217,229,0.3)",
            "white50": "rgba(205,217,229,0.5)",
            "white70": "rgba(205,217,229,0.7)",
            "white85": "rgba(205,217,229,0.85)"
          },
          "alert": {
            "info": {
              "text": "#adbac7",
              "icon": "#539bf5",
              "bg": "rgba(65,132,228,0.15)",
              "border": "rgba(65,132,228,0.4)"
            },
            "warn": {
              "text": "#adbac7",
              "icon": "#c69026",
              "bg": "rgba(174,124,20,0.15)",
              "border": "rgba(174,124,20,0.4)"
            },
            "error": {
              "text": "#adbac7",
              "icon": "#e5534b",
              "bg": "rgba(229,83,75,0.15)",
              "border": "rgba(229,83,75,0.4)"
            },
            "success": {
              "text": "#adbac7",
              "icon": "#57ab5a",
              "bg": "rgba(70,149,74,0.15)",
              "border": "rgba(70,149,74,0.4)"
            }
          },
          "autocomplete": {
            "rowBorder": "#373e47"
          },
          "blankslate": {
            "icon": "#768390"
          },
          "counter": {
            "text": "#adbac7",
            "bg": "rgba(99,110,123,0.4)",
            "primary": {
              "text": "#cdd9e5",
              "bg": "#636e7b"
            },
            "secondary": {
              "text": "#768390",
              "bg": "rgba(99,110,123,0.1)"
            }
          },
          "box": {
            "blueBorder": "rgba(65,132,228,0.4)",
            "rowYellowBg": "rgba(174,124,20,0.15)",
            "rowBlueBg": "rgba(65,132,228,0.15)",
            "headerBlueBg": "rgba(65,132,228,0.15)",
            "headerBlueBorder": "rgba(65,132,228,0.4)",
            "borderInfo": "rgba(65,132,228,0.4)",
            "bgInfo": "rgba(65,132,228,0.15)",
            "borderWarning": "rgba(174,124,20,0.4)",
            "bgWarning": "rgba(174,124,20,0.15)"
          },
          "branchName": {
            "text": "#768390",
            "icon": "#768390",
            "bg": "rgba(65,132,228,0.15)",
            "link": {
              "text": "#539bf5",
              "icon": "#539bf5",
              "bg": "rgba(65,132,228,0.15)"
            }
          },
          "markdown": {
            "codeBg": "rgba(99,110,123,0.4)",
            "frameBorder": "#444c56",
            "blockquoteBorder": "#444c56",
            "tableBorder": "#444c56",
            "tableTrBorder": "#373e47"
          },
          "filterItem": {
            "barBg": "rgba(99,110,123,0.1)"
          },
          "hiddenTextExpander": {
            "bg": "rgba(99,110,123,0.4)",
            "bgHover": "rgba(65,132,228,0.4)"
          },
          "dragAndDrop": {
            "border": "#444c56"
          },
          "uploadEnabled": {
            "border": "#444c56",
            "borderFocused": "#316dca"
          },
          "previewableCommentForm": {
            "border": "#444c56"
          },
          "verifiedBadge": {
            "text": "#57ab5a",
            "bg": "#22272e",
            "border": "#444c56"
          },
          "socialCount": {
            "bg": "#22272e"
          },
          "tooltip": {
            "text": "#cdd9e5",
            "bg": "#636e7b"
          },
          "filesExplorerIcon": "#539bf5",
          "hlAuthorBg": "rgba(65,132,228,0.15)",
          "hlAuthorBorder": "rgba(65,132,228,0.4)",
          "logoSubdued": "rgba(99,110,123,0.4)",
          "discussionBorder": "rgba(70,149,74,0.4)",
          "discussionBgSuccess": "#347d39",
          "actionsWorkflowTableStickyBg": "rgba(34,39,46,0.95)",
          "repoLanguageColorBorder": "rgba(205,217,229,0.2)",
          "codeSelectionBg": "rgba(65,132,228,0.4)",
          "highlight": {
            "text": "#adbac7",
            "bg": "rgba(174,124,20,0.15)"
          },
          "blob": {
            "lineHighlightBg": "rgba(174,124,20,0.15)",
            "lineHighlightBorder": "rgba(174,124,20,0.4)"
          },
          "topicTag": {
            "text": "#539bf5",
            "bg": "rgba(65,132,228,0.15)",
            "hoverBg": "#316dca",
            "activeBg": "rgba(65,132,228,0.15)",
            "border": "rgba(0,0,0,0)"
          },
          "footerInvertocat": {
            "octicon": "#545d68",
            "octiconHover": "#768390"
          },
          "label": {
            "border": "#444c56",
            "primary": {
              "text": "#adbac7",
              "border": "#636e7b"
            },
            "secondary": {
              "text": "#768390",
              "border": "#444c56"
            },
            "info": {
              "text": "#539bf5",
              "border": "#316dca"
            },
            "success": {
              "text": "#57ab5a",
              "border": "#347d39"
            },
            "warning": {
              "text": "#c69026",
              "border": "#966600"
            },
            "danger": {
              "text": "#e5534b",
              "border": "#c93c37"
            },
            "orange": {
              "text": "#cc6b2c",
              "border": "#ae5622"
            }
          },
          "input": {
            "bg": "#22272e",
            "contrastBg": "#1c2128",
            "border": "#444c56",
            "disabledBorder": "#444c56",
            "warningBorder": "#966600",
            "errorBorder": "#c93c37",
            "tooltip": {
              "success": {
                "text": "#adbac7",
                "bg": "rgba(70,149,74,0.15)",
                "border": "rgba(70,149,74,0.4)"
              },
              "warning": {
                "text": "#adbac7",
                "bg": "rgba(174,124,20,0.15)",
                "border": "rgba(174,124,20,0.4)"
              },
              "error": {
                "text": "#adbac7",
                "bg": "rgba(229,83,75,0.15)",
                "border": "rgba(229,83,75,0.4)"
              }
            },
            "disabledBg": "rgba(99,110,123,0)"
          },
          "toast": {
            "text": "#adbac7",
            "bg": "#22272e",
            "border": "#444c56",
            "icon": "#cdd9e5",
            "iconBg": "#316dca",
            "iconBorder": "rgba(0,0,0,0)",
            "success": {
              "text": "#adbac7",
              "border": "#444c56",
              "icon": "#cdd9e5",
              "iconBg": "#347d39",
              "iconBorder": "rgba(0,0,0,0)"
            },
            "warning": {
              "text": "#adbac7",
              "border": "#444c56",
              "icon": "#adbac7",
              "iconBg": "#966600",
              "iconBorder": "rgba(0,0,0,0)"
            },
            "danger": {
              "text": "#adbac7",
              "border": "#444c56",
              "icon": "#cdd9e5",
              "iconBg": "#c93c37",
              "iconBorder": "rgba(0,0,0,0)"
            },
            "loading": {
              "text": "#adbac7",
              "border": "#444c56",
              "icon": "#cdd9e5",
              "iconBg": "#636e7b",
              "iconBorder": "rgba(0,0,0,0)"
            }
          },
          "timeline": {
            "text": "#768390",
            "badgeSuccessBorder": "rgba(0,0,0,0)",
            "targetBadgeBorder": "#316dca",
            "targetBadgeShadow": "rgba(65,132,228,0.4)",
            "badgeBg": "#373e47"
          },
          "diffstat": {
            "neutralBg": "rgba(99,110,123,0.4)",
            "neutralBorder": "rgba(205,217,229,0.1)",
            "deletionBorder": "rgba(205,217,229,0.1)",
            "additionBorder": "rgba(205,217,229,0.1)",
            "deletionBg": "#c93c37",
            "additionBg": "#57ab5a"
          },
          "diff": {
            "addition": {
              "text": "#adbac7",
              "bg": "rgba(70,149,74,0.15)",
              "border": "rgba(70,149,74,0.4)"
            },
            "deletion": {
              "text": "#adbac7",
              "bg": "rgba(229,83,75,0.15)",
              "border": "rgba(229,83,75,0.4)"
            },
            "change": {
              "text": "#c69026",
              "bg": "rgba(174,124,20,0.15)",
              "border": "rgba(174,124,20,0.4)"
            }
          },
          "mergeBox": {
            "successIconBg": "#347d39",
            "successIconText": "#cdd9e5",
            "successIconBorder": "rgba(0,0,0,0)",
            "successIndicatorBg": "#347d39",
            "successIndicatorBorder": "rgba(0,0,0,0)",
            "mergedIconBg": "#8256d0",
            "mergedIconText": "#cdd9e5",
            "mergedIconBorder": "rgba(0,0,0,0)",
            "mergedBoxBorder": "#8256d0",
            "neutralIconBg": "#636e7b",
            "neutralIconText": "#cdd9e5",
            "neutralIconBorder": "rgba(0,0,0,0)",
            "neutralIndicatorBg": "#636e7b",
            "neutralIndicatorBorder": "rgba(0,0,0,0)",
            "warningIconBg": "#966600",
            "warningIconText": "#cdd9e5",
            "warningIconBorder": "rgba(0,0,0,0)",
            "warningBoxBorder": "#966600",
            "warningMergeHighlight": "rgba(0,0,0,0)",
            "errorIconBg": "#c93c37",
            "errorIconText": "#cdd9e5",
            "errorIconBorder": "rgba(0,0,0,0)",
            "errorIndicatorBg": "#c93c37",
            "errorIndicatorBorder": "rgba(0,0,0,0)"
          },
          "underlinenav": {
            "border": "rgba(0,0,0,0)",
            "borderHover": "rgba(99,110,123,0.4)",
            "borderActive": "#EC775C",
            "text": "#adbac7",
            "textHover": "#adbac7",
            "textActive": "#adbac7",
            "icon": "#545d68",
            "iconHover": "#545d68",
            "iconActive": "#adbac7",
            "counterText": "#adbac7",
            "counterBg": "rgba(99,110,123,0.4)"
          },
          "selectMenu": {
            "borderSecondary": "#373e47",
            "backdropBg": "rgba(28,33,40,0.8)",
            "backdropBorder": "#545d68",
            "tapHighlight": "rgba(68,76,86,0.5)",
            "tapFocusBg": "#143d79"
          },
          "sidenav": {
            "borderActive": "#EC775C",
            "selectedBg": "#373e47"
          },
          "menu": {
            "headingText": "#adbac7",
            "borderActive": "#EC775C",
            "bgActive": "#2d333b"
          },
          "project": {
            "cardBg": "#2d333b",
            "headerBg": "#22272e",
            "sidebarBg": "#2d333b",
            "gradientIn": "#2d333b",
            "gradientOut": "rgba(45,51,59,0)"
          },
          "prState": {
            "draft": {
              "text": "#cdd9e5",
              "bg": "#636e7b",
              "border": "rgba(0,0,0,0)"
            },
            "open": {
              "text": "#cdd9e5",
              "bg": "#347d39",
              "border": "rgba(0,0,0,0)"
            },
            "merged": {
              "text": "#cdd9e5",
              "bg": "#8256d0",
              "border": "rgba(0,0,0,0)"
            },
            "closed": {
              "text": "#cdd9e5",
              "bg": "#c93c37",
              "border": "rgba(0,0,0,0)"
            }
          },
          "diffBlob": {
            "numText": "#545d68",
            "numHoverText": "#adbac7",
            "addition": {
              "numHoverText": "#adbac7",
              "numText": "#adbac7",
              "fg": "#adbac7",
              "numBg": "rgba(87,171,90,0.3)",
              "lineBg": "rgba(70,149,74,0.15)",
              "wordBg": "rgba(70,149,74,0.4)"
            },
            "deletion": {
              "numHoverText": "#adbac7",
              "numText": "#adbac7",
              "fg": "#adbac7",
              "numBg": "rgba(229,83,75,0.3)",
              "lineBg": "rgba(229,83,75,0.15)",
              "wordBg": "rgba(229,83,75,0.4)"
            },
            "hunk": {
              "text": "#768390",
              "numBg": "rgba(65,132,228,0.4)",
              "lineBg": "rgba(65,132,228,0.15)"
            },
            "emptyBlockBg": "rgba(99,110,123,0.1)",
            "selectedLineHighlightBg": "rgba(174,124,20,0.15)",
            "selectedLineHighlightBorder": "rgba(174,124,20,0.4)",
            "expander": {
              "hoverIcon": "#cdd9e5",
              "hoverBg": "#316dca",
              "icon": "#768390"
            },
            "commentButton": {
              "icon": "#cdd9e5",
              "bg": "#316dca",
              "gradientBg": "rgba(0,0,0,0)"
            }
          },
          "globalNav": {
            "logo": "#cdd9e5",
            "bg": "#2d333b",
            "text": "#adbac7",
            "icon": "#adbac7",
            "inputBg": "#22272e",
            "inputBorder": "#373e47",
            "inputIcon": "#373e47",
            "inputPlaceholder": "#545d68"
          },
          "introShelf": {
            "gradientLeft": "rgba(65,132,228,0.15)",
            "gradientRight": "rgba(70,149,74,0.15)",
            "gradientIn": "#22272e",
            "gradientOut": "rgba(205,217,229,0)"
          },
          "canvasDefaultTransparent": "rgba(34,39,46,0)",
          "marketingIcon": {
            "primary": "#6cb6ff",
            "secondary": "#316dca"
          },
          "searchKeyword": {
            "hl": "rgba(198,144,38,0.4)"
          },
          "prettylights": {
            "syntax": {
              "comment": "#768390",
              "constant": "#6cb6ff",
              "entity": "#dcbdfb",
              "storageModifierImport": "#adbac7",
              "entityTag": "#8ddb8c",
              "keyword": "#f47067",
              "string": "#96d0ff",
              "variable": "#f69d50",
              "brackethighlighterUnmatched": "#e5534b",
              "invalidIllegalText": "#cdd9e5",
              "invalidIllegalBg": "#922323",
              "carriageReturnText": "#cdd9e5",
              "carriageReturnBg": "#ad2e2c",
              "stringRegexp": "#8ddb8c",
              "markupList": "#eac55f",
              "markupHeading": "#316dca",
              "markupItalic": "#adbac7",
              "markupBold": "#adbac7",
              "markupDeletedText": "#ffd8d3",
              "markupDeletedBg": "#78191b",
              "markupInsertedText": "#b4f1b4",
              "markupInsertedBg": "#1b4721",
              "markupChangedText": "#ffddb0",
              "markupChangedBg": "#682d0f",
              "markupIgnoredText": "#adbac7",
              "markupIgnoredBg": "#255ab2",
              "metaDiffRange": "#dcbdfb",
              "brackethighlighterAngle": "#768390",
              "sublimelinterGutterMark": "#545d68",
              "constantOtherReferenceLink": "#96d0ff"
            }
          },
          "codemirror": {
            "text": "#adbac7",
            "bg": "#22272e",
            "guttersBg": "#22272e",
            "guttermarkerText": "#22272e",
            "guttermarkerSubtleText": "#545d68",
            "linenumberText": "#768390",
            "cursor": "#adbac7",
            "selectionBg": "rgba(65,132,228,0.4)",
            "activelineBg": "rgba(99,110,123,0.1)",
            "matchingbracketText": "#adbac7",
            "linesBg": "#22272e",
            "syntax": {
              "comment": "#768390",
              "constant": "#6cb6ff",
              "entity": "#dcbdfb",
              "keyword": "#f47067",
              "storage": "#f47067",
              "string": "#96d0ff",
              "support": "#6cb6ff",
              "variable": "#f69d50"
            }
          },
          "checks": {
            "bg": "#1c2128",
            "textPrimary": "#adbac7",
            "textSecondary": "#768390",
            "textLink": "#539bf5",
            "btnIcon": "#768390",
            "btnHoverIcon": "#adbac7",
            "btnHoverBg": "rgba(99,110,123,0.1)",
            "inputText": "#768390",
            "inputPlaceholderText": "#545d68",
            "inputFocusText": "#adbac7",
            "inputBg": "#2d333b",
            "donutError": "#e5534b",
            "donutPending": "#c69026",
            "donutSuccess": "#46954a",
            "donutNeutral": "#768390",
            "dropdownText": "#adbac7",
            "dropdownBg": "#2d333b",
            "dropdownBorder": "#444c56",
            "dropdownShadow": "rgba(28,33,40,0.3)",
            "dropdownHoverText": "#adbac7",
            "dropdownHoverBg": "rgba(99,110,123,0.1)",
            "dropdownBtnHoverText": "#adbac7",
            "dropdownBtnHoverBg": "rgba(99,110,123,0.1)",
            "scrollbarThumbBg": "rgba(99,110,123,0.4)",
            "headerLabelText": "#768390",
            "headerLabelOpenText": "#adbac7",
            "headerBorder": "#373e47",
            "headerIcon": "#768390",
            "lineText": "#768390",
            "lineNumText": "#545d68",
            "lineTimestampText": "#545d68",
            "lineHoverBg": "rgba(99,110,123,0.1)",
            "lineSelectedBg": "rgba(65,132,228,0.15)",
            "lineSelectedNumText": "#539bf5",
            "lineDtFmText": "#cdd9e5",
            "lineDtFmBg": "#966600",
            "gateBg": "rgba(174,124,20,0.15)",
            "gateText": "#768390",
            "gateWaitingText": "#c69026",
            "stepHeaderOpenBg": "#2d333b",
            "stepErrorText": "#e5534b",
            "stepWarningText": "#c69026",
            "loglineText": "#768390",
            "loglineNumText": "#545d68",
            "loglineDebugText": "#986ee2",
            "loglineErrorText": "#768390",
            "loglineErrorNumText": "#545d68",
            "loglineErrorBg": "rgba(229,83,75,0.15)",
            "loglineWarningText": "#768390",
            "loglineWarningNumText": "#c69026",
            "loglineWarningBg": "rgba(174,124,20,0.15)",
            "loglineCommandText": "#539bf5",
            "loglineSectionText": "#57ab5a",
            "ansi": {
              "black": "#22272e",
              "blackBright": "#2d333b",
              "white": "#909dab",
              "whiteBright": "#909dab",
              "gray": "#636e7b",
              "red": "#f47067",
              "redBright": "#ff938a",
              "green": "#57ab5a",
              "greenBright": "#6bc46d",
              "yellow": "#c69026",
              "yellowBright": "#daaa3f",
              "blue": "#539bf5",
              "blueBright": "#6cb6ff",
              "magenta": "#b083f0",
              "magentaBright": "#dcbdfb",
              "cyan": "#76e3ea",
              "cyanBright": "#b3f0ff"
            }
          },
          "mktg": {
            "success": "rgba(61,137,66,1)",
            "info": "rgba(56,119,213,1)",
            "bgShadeGradient": {
              "top": "rgba(28,33,40,0.065)",
              "bottom": "rgba(28,33,40,0)"
            },
            "btn": {
              "bg": {
                "top": "hsla(228,82%,66%,1)",
                "bottom": "#4969ed"
              },
              "bgOverlay": {
                "top": "hsla(228,74%,59%,1)",
                "bottom": "#3355e0"
              },
              "text": "#cdd9e5",
              "primary": {
                "bg": {
                  "top": "hsla(137,56%,46%,1)",
                  "bottom": "#2ea44f"
                },
                "bgOverlay": {
                  "top": "hsla(134,60%,38%,1)",
                  "bottom": "#22863a"
                },
                "text": "#cdd9e5"
              },
              "enterprise": {
                "bg": {
                  "top": "hsla(249,100%,72%,1)",
                  "bottom": "#6f57ff"
                },
                "bgOverlay": {
                  "top": "hsla(248,65%,63%,1)",
                  "bottom": "#614eda"
                },
                "text": "#cdd9e5"
              },
              "outline": {
                "text": "#cdd9e5",
                "border": "rgba(205,217,229,0.3)",
                "hover": {
                  "text": "#cdd9e5",
                  "border": "rgba(205,217,229,0.5)"
                },
                "focus": {
                  "border": "#cdd9e5",
                  "borderInset": "rgba(205,217,229,0.5)"
                }
              },
              "dark": {
                "text": "#cdd9e5",
                "border": "rgba(205,217,229,0.3)",
                "hover": {
                  "text": "#cdd9e5",
                  "border": "rgba(205,217,229,0.5)"
                },
                "focus": {
                  "border": "#cdd9e5",
                  "borderInset": "rgba(205,217,229,0.5)"
                }
              }
            }
          },
          "avatar": {
            "bg": "rgba(205,217,229,0.1)",
            "border": "rgba(205,217,229,0.1)",
            "stackFade": "#444c56",
            "stackFadeMore": "#373e47"
          },
          "header": {
            "text": "rgba(205,217,229,0.7)",
            "bg": "#2d333b",
            "logo": "#cdd9e5"
          },
          "headerSearch": {
            "bg": "#22272e",
            "border": "#444c56"
          },
          "ansi": {
            "black": "#545d68",
            "blackBright": "#636e7b",
            "white": "#909dab",
            "whiteBright": "#cdd9e5",
            "gray": "#636e7b",
            "red": "#f47067",
            "redBright": "#ff938a",
            "green": "#57ab5a",
            "greenBright": "#6bc46d",
            "yellow": "#c69026",
            "yellowBright": "#daaa3f",
            "blue": "#539bf5",
            "blueBright": "#6cb6ff",
            "magenta": "#b083f0",
            "magentaBright": "#dcbdfb",
            "cyan": "#39c5cf",
            "cyanBright": "#56d4dd"
          },
          "btn": {
            "text": "#adbac7",
            "bg": "#373e47",
            "border": "rgba(205,217,229,0.1)",
            "hoverBg": "#444c56",
            "hoverBorder": "#768390",
            "activeBg": "hsla(213,12%,27%,1)",
            "activeBorder": "#636e7b",
            "selectedBg": "#2d333b",
            "focusBg": "#373e47",
            "focusBorder": "#768390",
            "counterBg": "#444c56",
            "primary": {
              "text": "#ffffff",
              "bg": "#347d39",
              "border": "rgba(205,217,229,0.1)",
              "hoverBg": "#46954a",
              "hoverBorder": "rgba(205,217,229,0.1)",
              "selectedBg": "#347d39",
              "disabledText": "rgba(205,217,229,0.5)",
              "disabledBg": "rgba(52,125,57,0.6)",
              "disabledBorder": "rgba(205,217,229,0.1)",
              "focusBg": "#347d39",
              "focusBorder": "rgba(205,217,229,0.1)",
              "icon": "#cdd9e5",
              "counterBg": "rgba(205,217,229,0.2)"
            },
            "outline": {
              "text": "#539bf5",
              "hoverText": "#539bf5",
              "hoverBg": "#444c56",
              "hoverBorder": "rgba(205,217,229,0.1)",
              "hoverCounterBg": "rgba(205,217,229,0.2)",
              "selectedText": "#cdd9e5",
              "selectedBg": "#1b4b91",
              "selectedBorder": "rgba(205,217,229,0.1)",
              "disabledText": "rgba(83,155,245,0.5)",
              "disabledBg": "#22272e",
              "disabledCounterBg": "rgba(49,109,202,0.05)",
              "focusBorder": "rgba(205,217,229,0.1)",
              "counterBg": "rgba(49,109,202,0.1)"
            },
            "danger": {
              "text": "#e5534b",
              "hoverText": "#cdd9e5",
              "hoverBg": "#c93c37",
              "hoverBorder": "#e5534b",
              "hoverIcon": "#cdd9e5",
              "hoverCounterBg": "rgba(255,255,255,0.2)",
              "selectedText": "#ffffff",
              "selectedBg": "#ad2e2c",
              "selectedBorder": "#f47067",
              "disabledText": "rgba(229,83,75,0.5)",
              "disabledBg": "#22272e",
              "disabledCounterBg": "rgba(201,60,55,0.05)",
              "focusBorder": "#e5534b",
              "counterBg": "rgba(201,60,55,0.1)",
              "icon": "#e5534b"
            }
          },
          "fg": {
            "default": "#adbac7",
            "muted": "#768390",
            "subtle": "#545d68",
            "onEmphasis": "#cdd9e5"
          },
          "canvas": {
            "default": "#22272e",
            "overlay": "#2d333b",
            "inset": "#1c2128",
            "subtle": "#2d333b"
          },
          "neutral": {
            "emphasisPlus": "#636e7b",
            "emphasis": "#636e7b",
            "muted": "rgba(99,110,123,0.4)",
            "subtle": "rgba(99,110,123,0.1)"
          },
          "accent": {
            "fg": "#539bf5",
            "emphasis": "#316dca",
            "muted": "rgba(65,132,228,0.4)",
            "subtle": "rgba(65,132,228,0.15)"
          },
          "success": {
            "fg": "#57ab5a",
            "emphasis": "#347d39",
            "muted": "rgba(70,149,74,0.4)",
            "subtle": "rgba(70,149,74,0.15)"
          },
          "attention": {
            "fg": "#c69026",
            "emphasis": "#966600",
            "muted": "rgba(174,124,20,0.4)",
            "subtle": "rgba(174,124,20,0.15)"
          },
          "severe": {
            "fg": "#cc6b2c",
            "emphasis": "#ae5622",
            "muted": "rgba(204,107,44,0.4)",
            "subtle": "rgba(204,107,44,0.15)"
          },
          "danger": {
            "fg": "#e5534b",
            "emphasis": "#c93c37",
            "muted": "rgba(229,83,75,0.4)",
            "subtle": "rgba(229,83,75,0.15)"
          },
          "done": {
            "fg": "#986ee2",
            "emphasis": "#8256d0",
            "muted": "rgba(152,110,226,0.4)",
            "subtle": "rgba(152,110,226,0.15)"
          },
          "sponsors": {
            "fg": "#c96198",
            "emphasis": "#ae4c82",
            "muted": "rgba(201,97,152,0.4)",
            "subtle": "rgba(201,97,152,0.15)"
          },
          "primer": {
            "canvas": {
              "backdrop": "rgba(28,33,40,0.8)",
              "sticky": "rgba(34,39,46,0.95)"
            },
            "border": {
              "active": "#EC775C",
              "contrast": "rgba(205,217,229,0.2)"
            }
          }
        },
        "shadows": {
          "shadow": {
            "highlight": "0 0 transparent",
            "inset": "0 0 transparent",
            "small": "0 0 transparent",
            "medium": "0 3px 6px #1c2128",
            "large": "0 8px 24px #1c2128",
            "extraLarge": "0 12px 48px #1c2128"
          },
          "state": {
            "focus": {
              "shadow": "0 0 0 3px #143d79"
            }
          },
          "autocomplete": {
            "shadow": "0 3px 6px #1c2128"
          },
          "dropdown": {
            "shadow": "0 8px 24px #1c2128"
          },
          "input": {
            "shadow": "0 0 transparent"
          },
          "toast": {
            "shadow": "0 8px 24px #1c2128"
          },
          "selectMenu": {
            "shadow": "0 8px 24px #1c2128"
          },
          "checks": {
            "inputShadow": "0 0 0 1px (obj) => get_1.default(obj, path)"
          },
          "avatar": {
            "childShadow": "-2px -2px 0 #22272e"
          },
          "overlay": {
            "shadow": "0 0 0 1px #444c56, 0 16px 32px rgba(28,33,40,0.85)"
          },
          "btn": {
            "shadow": "0 0 transparent",
            "insetShadow": "0 0 transparent",
            "focusShadow": "0 0 0 3px rgba(118,131,144,0.3)",
            "shadowActive": "inset 0 0.15em 0.3em rgba(28,33,40,0.15)",
            "shadowInputFocus": "0 0 0 0.2em rgba(49,109,202,0.3)",
            "primary": {
              "shadow": "0 0 transparent",
              "insetShadow": "0 0 transparent",
              "selectedShadow": "0 0 transparent",
              "focusShadow": "0 0 0 3px rgba(46,164,79,0.4)"
            },
            "outline": {
              "hoverShadow": "0 1px 0 rgba(28,33,40,0.1)",
              "hoverInsetShadow": "inset 0 1px 0 rgba(205,217,229,0.03)",
              "selectedShadow": "0 0 transparent",
              "focusShadow": "0 0 0 3px rgba(37,90,178,0.4)"
            },
            "danger": {
              "hoverShadow": "0 0 transparent",
              "hoverInsetShadow": "0 0 transparent",
              "selectedShadow": "0 0 transparent",
              "focusShadow": "0 0 0 3px rgba(229,83,75,0.4)"
            }
          },
          "primer": {
            "shadow": {
              "highlight": "0 0 transparent",
              "inset": "0 0 transparent",
              "focus": "0 0 0 3px #143d79"
            }
          }
        }
      },
      "dark_high_contrast": {
        "colors": {
          "auto": {
            "black": "#ffffff",
            "white": "#010409",
            "gray": ["#0a0c10", "#272b33", "#272b33", "#525964", "#7a828e", "#9ea7b3", "#bdc4cc", "#d9dee3", "#f0f3f6", "#ffffff"],
            "blue": ["#194fb1", "#1e60d5", "#2672f3", "#318bf8", "#409eff", "#409eff", "#71b7ff", "#91cbff", "#addcff", "#caeaff"],
            "green": ["#006222", "#007728", "#008c2c", "#02a232", "#09b43a", "#09b43a", "#26cd4d", "#4ae168", "#72f088", "#acf7b6"],
            "yellow": ["#7b4900", "#945d02", "#ae7104", "#c88508", "#e09b13", "#e09b13", "#f0b72f", "#f7c843", "#fbd669", "#fbe59e"],
            "orange": ["#8f3c00", "#a74c00", "#bf5e0a", "#d57014", "#e7811d", "#e7811d", "#fe9a2d", "#ffb757", "#ffcf86", "#ffe1b4"],
            "red": ["#ad0116", "#cc1421", "#e82a2f", "#ff4445", "#ff6a69", "#ff6a69", "#ff9492", "#ffb1af", "#ffc9c7", "#ffdedb"],
            "purple": ["#6921d7", "#8031f7", "#954ffd", "#a66bff", "#b87fff", "#b780ff", "#cb9eff", "#dbb7ff", "#e6ccff", "#f0dfff"],
            "pink": ["#9c1d6a", "#b72c7d", "#d23d91", "#e456a3", "#ef6eb1", "#ef6eb1", "#ff8dc7", "#ffadd4", "#ffc7e1", "#ffdceb"]
          },
          "text": {
            "primary": "#f0f3f6",
            "secondary": "#f0f3f6",
            "tertiary": "#f0f3f6",
            "placeholder": "#7a828e",
            "disabled": "#f0f3f6",
            "inverse": "#0a0c10",
            "link": "#71b7ff",
            "danger": "#ff6a69",
            "success": "#26cd4d",
            "warning": "#f0b72f",
            "white": "#ffffff"
          },
          "icon": {
            "primary": "#f0f3f6",
            "secondary": "#f0f3f6",
            "tertiary": "#f0f3f6",
            "info": "#71b7ff",
            "danger": "#ff6a69",
            "success": "#26cd4d",
            "warning": "#f0b72f"
          },
          "border": {
            "primary": "#7a828e",
            "secondary": "#7a828e",
            "tertiary": "#7a828e",
            "overlay": "#7a828e",
            "inverse": "#0a0c10",
            "info": "#409eff",
            "danger": "#ff6a69",
            "success": "#09b43a",
            "warning": "#e09b13",
            "default": "#7a828e",
            "muted": "#7a828e",
            "subtle": "#7a828e"
          },
          "bg": {
            "canvas": "#0a0c10",
            "canvasMobile": "rgba(0,0,0,0)",
            "canvasInverse": "#9ea7b3",
            "canvasInset": "#010409",
            "primary": "#0a0c10",
            "secondary": "#272b33",
            "tertiary": "#272b33",
            "overlay": "#272b33",
            "backdrop": "rgba(1,4,9,0.8)",
            "info": "rgba(64,158,255,0.15)",
            "infoInverse": "#409eff",
            "danger": "rgba(255,106,105,0.15)",
            "dangerInverse": "#ff6a69",
            "success": "rgba(9,180,58,0.15)",
            "successInverse": "#09b43a",
            "warning": "rgba(224,155,19,0.15)",
            "warningInverse": "#e09b13"
          },
          "state": {
            "hover": {
              "primaryBg": "#409eff",
              "primaryBorder": "#409eff",
              "primaryText": "#0a0c10",
              "primaryIcon": "#0a0c10",
              "secondaryBg": "rgba(158,167,179,0.1)",
              "secondaryBorder": "rgba(158,167,179,0.1)"
            },
            "selected": {
              "primaryBg": "#409eff",
              "primaryBorder": "#409eff",
              "primaryText": "#0a0c10",
              "primaryIcon": "#0a0c10"
            },
            "focus": {
              "border": "#409eff"
            }
          },
          "fade": {
            "fg10": "rgba(255,255,255,0.1)",
            "fg15": "rgba(255,255,255,0.15)",
            "fg30": "rgba(255,255,255,0.3)",
            "fg50": "rgba(255,255,255,0.5)",
            "fg70": "rgba(255,255,255,0.7)",
            "fg85": "rgba(255,255,255,0.85)",
            "black10": "rgba(1,4,9,0.1)",
            "black15": "rgba(1,4,9,0.15)",
            "black30": "rgba(1,4,9,0.3)",
            "black50": "rgba(1,4,9,0.5)",
            "black70": "rgba(1,4,9,0.7)",
            "black85": "rgba(1,4,9,0.85)",
            "white10": "rgba(255,255,255,0.1)",
            "white15": "rgba(255,255,255,0.15)",
            "white30": "rgba(255,255,255,0.3)",
            "white50": "rgba(255,255,255,0.5)",
            "white70": "rgba(255,255,255,0.7)",
            "white85": "rgba(255,255,255,0.85)"
          },
          "alert": {
            "info": {
              "text": "#f0f3f6",
              "icon": "#71b7ff",
              "bg": "rgba(64,158,255,0.15)",
              "border": "#409eff"
            },
            "warn": {
              "text": "#f0f3f6",
              "icon": "#f0b72f",
              "bg": "rgba(224,155,19,0.15)",
              "border": "#e09b13"
            },
            "error": {
              "text": "#f0f3f6",
              "icon": "#ff6a69",
              "bg": "rgba(255,106,105,0.15)",
              "border": "#ff6a69"
            },
            "success": {
              "text": "#f0f3f6",
              "icon": "#26cd4d",
              "bg": "rgba(9,180,58,0.15)",
              "border": "#09b43a"
            }
          },
          "autocomplete": {
            "rowBorder": "#7a828e"
          },
          "blankslate": {
            "icon": "#f0f3f6"
          },
          "counter": {
            "text": "#f0f3f6",
            "bg": "rgba(158,167,179,0.4)",
            "primary": {
              "text": "#0a0c10",
              "bg": "#9ea7b3"
            },
            "secondary": {
              "text": "#f0f3f6",
              "bg": "rgba(158,167,179,0.1)"
            }
          },
          "box": {
            "blueBorder": "#409eff",
            "rowYellowBg": "rgba(224,155,19,0.15)",
            "rowBlueBg": "rgba(64,158,255,0.15)",
            "headerBlueBg": "rgba(64,158,255,0.15)",
            "headerBlueBorder": "#409eff",
            "borderInfo": "#409eff",
            "bgInfo": "rgba(64,158,255,0.15)",
            "borderWarning": "#e09b13",
            "bgWarning": "rgba(224,155,19,0.15)"
          },
          "branchName": {
            "text": "#f0f3f6",
            "icon": "#f0f3f6",
            "bg": "rgba(64,158,255,0.15)",
            "link": {
              "text": "#71b7ff",
              "icon": "#71b7ff",
              "bg": "rgba(64,158,255,0.15)"
            }
          },
          "markdown": {
            "codeBg": "rgba(158,167,179,0.4)",
            "frameBorder": "#7a828e",
            "blockquoteBorder": "#7a828e",
            "tableBorder": "#7a828e",
            "tableTrBorder": "#7a828e"
          },
          "filterItem": {
            "barBg": "rgba(158,167,179,0.1)"
          },
          "hiddenTextExpander": {
            "bg": "rgba(158,167,179,0.4)",
            "bgHover": "#409eff"
          },
          "dragAndDrop": {
            "border": "#7a828e"
          },
          "uploadEnabled": {
            "border": "#7a828e",
            "borderFocused": "#409eff"
          },
          "previewableCommentForm": {
            "border": "#7a828e"
          },
          "verifiedBadge": {
            "text": "#26cd4d",
            "bg": "#0a0c10",
            "border": "#7a828e"
          },
          "socialCount": {
            "bg": "#0a0c10"
          },
          "tooltip": {
            "text": "#0a0c10",
            "bg": "#ffffff"
          },
          "filesExplorerIcon": "#71b7ff",
          "hlAuthorBg": "rgba(64,158,255,0.15)",
          "hlAuthorBorder": "#409eff",
          "logoSubdued": "rgba(158,167,179,0.4)",
          "discussionBorder": "#09b43a",
          "discussionBgSuccess": "#09b43a",
          "actionsWorkflowTableStickyBg": "rgba(10,12,16,0.95)",
          "repoLanguageColorBorder": "rgba(255,255,255,0.2)",
          "codeSelectionBg": "#409eff",
          "highlight": {
            "text": "#f0f3f6",
            "bg": "rgba(224,155,19,0.15)"
          },
          "blob": {
            "lineHighlightBg": "rgba(224,155,19,0.15)",
            "lineHighlightBorder": "#e09b13"
          },
          "topicTag": {
            "text": "#71b7ff",
            "bg": "rgba(64,158,255,0.15)",
            "hoverBg": "#409eff",
            "activeBg": "rgba(64,158,255,0.15)",
            "border": "#409eff"
          },
          "footerInvertocat": {
            "octicon": "#7a828e",
            "octiconHover": "#f0f3f6"
          },
          "label": {
            "border": "#7a828e",
            "primary": {
              "text": "#f0f3f6",
              "border": "#9ea7b3"
            },
            "secondary": {
              "text": "#f0f3f6",
              "border": "#7a828e"
            },
            "info": {
              "text": "#71b7ff",
              "border": "#409eff"
            },
            "success": {
              "text": "#26cd4d",
              "border": "#09b43a"
            },
            "warning": {
              "text": "#f0b72f",
              "border": "#e09b13"
            },
            "danger": {
              "text": "#ff6a69",
              "border": "#ff6a69"
            },
            "orange": {
              "text": "#e7811d",
              "border": "#e7811d"
            }
          },
          "input": {
            "bg": "#0a0c10",
            "contrastBg": "#010409",
            "border": "#7a828e",
            "disabledBorder": "#7a828e",
            "warningBorder": "#e09b13",
            "errorBorder": "#ff6a69",
            "tooltip": {
              "success": {
                "text": "#f0f3f6",
                "bg": "rgba(9,180,58,0.15)",
                "border": "#09b43a"
              },
              "warning": {
                "text": "#f0f3f6",
                "bg": "rgba(224,155,19,0.15)",
                "border": "#e09b13"
              },
              "error": {
                "text": "#f0f3f6",
                "bg": "rgba(255,106,105,0.15)",
                "border": "#ff6a69"
              }
            },
            "disabledBg": "rgba(158,167,179,0)"
          },
          "toast": {
            "text": "#f0f3f6",
            "bg": "#0a0c10",
            "border": "#7a828e",
            "icon": "#0a0c10",
            "iconBg": "#409eff",
            "iconBorder": "rgba(0,0,0,0)",
            "success": {
              "text": "#f0f3f6",
              "border": "#7a828e",
              "icon": "#0a0c10",
              "iconBg": "#09b43a",
              "iconBorder": "rgba(0,0,0,0)"
            },
            "warning": {
              "text": "#f0f3f6",
              "border": "#7a828e",
              "icon": "#f0f3f6",
              "iconBg": "#e09b13",
              "iconBorder": "rgba(0,0,0,0)"
            },
            "danger": {
              "text": "#f0f3f6",
              "border": "#7a828e",
              "icon": "#0a0c10",
              "iconBg": "#ff6a69",
              "iconBorder": "rgba(0,0,0,0)"
            },
            "loading": {
              "text": "#f0f3f6",
              "border": "#7a828e",
              "icon": "#0a0c10",
              "iconBg": "#9ea7b3",
              "iconBorder": "rgba(0,0,0,0)"
            }
          },
          "timeline": {
            "text": "#f0f3f6",
            "badgeSuccessBorder": "rgba(0,0,0,0)",
            "targetBadgeBorder": "#409eff",
            "targetBadgeShadow": "#409eff",
            "badgeBg": "#272b33"
          },
          "diffstat": {
            "neutralBg": "rgba(158,167,179,0.4)",
            "neutralBorder": "#7a828e",
            "deletionBorder": "#ffb1af",
            "additionBorder": "#4ae168",
            "deletionBg": "#ff6a69",
            "additionBg": "#26cd4d"
          },
          "diff": {
            "addition": {
              "text": "#f0f3f6",
              "bg": "rgba(9,180,58,0.15)",
              "border": "#09b43a"
            },
            "deletion": {
              "text": "#f0f3f6",
              "bg": "rgba(255,106,105,0.15)",
              "border": "#ff6a69"
            },
            "change": {
              "text": "#f0b72f",
              "bg": "rgba(224,155,19,0.15)",
              "border": "#e09b13"
            }
          },
          "mergeBox": {
            "successIconBg": "#09b43a",
            "successIconText": "#0a0c10",
            "successIconBorder": "rgba(0,0,0,0)",
            "successIndicatorBg": "#09b43a",
            "successIndicatorBorder": "rgba(0,0,0,0)",
            "mergedIconBg": "#b87fff",
            "mergedIconText": "#0a0c10",
            "mergedIconBorder": "rgba(0,0,0,0)",
            "mergedBoxBorder": "#b87fff",
            "neutralIconBg": "#9ea7b3",
            "neutralIconText": "#0a0c10",
            "neutralIconBorder": "rgba(0,0,0,0)",
            "neutralIndicatorBg": "#9ea7b3",
            "neutralIndicatorBorder": "rgba(0,0,0,0)",
            "warningIconBg": "#e09b13",
            "warningIconText": "#0a0c10",
            "warningIconBorder": "rgba(0,0,0,0)",
            "warningBoxBorder": "#e09b13",
            "warningMergeHighlight": "rgba(0,0,0,0)",
            "errorIconBg": "#ff6a69",
            "errorIconText": "#0a0c10",
            "errorIconBorder": "rgba(0,0,0,0)",
            "errorIndicatorBg": "#ff6a69",
            "errorIndicatorBorder": "rgba(0,0,0,0)"
          },
          "underlinenav": {
            "border": "rgba(0,0,0,0)",
            "borderHover": "#bdc4cc",
            "borderActive": "#FF967D",
            "text": "#f0f3f6",
            "textHover": "#f0f3f6",
            "textActive": "#f0f3f6",
            "icon": "#f0f3f6",
            "iconHover": "#7a828e",
            "iconActive": "#f0f3f6",
            "counterText": "#f0f3f6",
            "counterBg": "rgba(158,167,179,0.4)"
          },
          "selectMenu": {
            "borderSecondary": "#7a828e",
            "backdropBg": "rgba(1,4,9,0.8)",
            "backdropBorder": "#7a828e",
            "tapHighlight": "rgba(82,89,100,0.5)",
            "tapFocusBg": "#1e60d5"
          },
          "sidenav": {
            "borderActive": "#FF967D",
            "selectedBg": "#272b33"
          },
          "menu": {
            "headingText": "#f0f3f6",
            "borderActive": "#FF967D",
            "bgActive": "#272b33"
          },
          "project": {
            "cardBg": "#272b33",
            "headerBg": "#0a0c10",
            "sidebarBg": "#272b33",
            "gradientIn": "#272b33",
            "gradientOut": "rgba(39,43,51,0)"
          },
          "prState": {
            "draft": {
              "text": "#0a0c10",
              "bg": "#9ea7b3",
              "border": "rgba(0,0,0,0)"
            },
            "open": {
              "text": "#0a0c10",
              "bg": "#09b43a",
              "border": "rgba(0,0,0,0)"
            },
            "merged": {
              "text": "#0a0c10",
              "bg": "#b87fff",
              "border": "rgba(0,0,0,0)"
            },
            "closed": {
              "text": "#0a0c10",
              "bg": "#ff6a69",
              "border": "rgba(0,0,0,0)"
            }
          },
          "diffBlob": {
            "numText": "#7a828e",
            "numHoverText": "#f0f3f6",
            "addition": {
              "numHoverText": "#f0f3f6",
              "numText": "#f0f3f6",
              "fg": "#0a0c10",
              "numBg": "rgba(38,205,77,0.3)",
              "lineBg": "rgba(9,180,58,0.15)",
              "wordBg": "#09b43a"
            },
            "deletion": {
              "numHoverText": "#f0f3f6",
              "numText": "#f0f3f6",
              "fg": "#0a0c10",
              "numBg": "rgba(255,106,105,0.3)",
              "lineBg": "rgba(255,106,105,0.15)",
              "wordBg": "#ff6a69"
            },
            "hunk": {
              "text": "#f0f3f6",
              "numBg": "rgba(64,158,255,0.4)",
              "lineBg": "rgba(64,158,255,0.15)"
            },
            "emptyBlockBg": "rgba(158,167,179,0.1)",
            "selectedLineHighlightBg": "rgba(224,155,19,0.15)",
            "selectedLineHighlightBorder": "#e09b13",
            "expander": {
              "hoverIcon": "#0a0c10",
              "hoverBg": "#409eff",
              "icon": "#0a0c10"
            },
            "commentButton": {
              "icon": "#0a0c10",
              "bg": "#409eff",
              "gradientBg": "rgba(0,0,0,0)"
            }
          },
          "globalNav": {
            "logo": "#ffffff",
            "bg": "#272b33",
            "text": "#f0f3f6",
            "icon": "#f0f3f6",
            "inputBg": "#0a0c10",
            "inputBorder": "#272b33",
            "inputIcon": "#272b33",
            "inputPlaceholder": "#7a828e"
          },
          "introShelf": {
            "gradientLeft": "rgba(64,158,255,0.15)",
            "gradientRight": "rgba(9,180,58,0.15)",
            "gradientIn": "#0a0c10",
            "gradientOut": "rgba(255,255,255,0)"
          },
          "canvasDefaultTransparent": "rgba(10,12,16,0)",
          "marketingIcon": {
            "primary": "#91cbff",
            "secondary": "#409eff"
          },
          "searchKeyword": {
            "hl": "rgba(240,183,47,0.4)"
          },
          "prettylights": {
            "syntax": {
              "comment": "#bdc4cc",
              "constant": "#91cbff",
              "entity": "#dbb7ff",
              "storageModifierImport": "#f0f3f6",
              "entityTag": "#72f088",
              "keyword": "#ff9492",
              "string": "#addcff",
              "variable": "#ffb757",
              "brackethighlighterUnmatched": "#ff6a69",
              "invalidIllegalText": "#ffffff",
              "invalidIllegalBg": "#e82a2f",
              "carriageReturnText": "#ffffff",
              "carriageReturnBg": "#ff4445",
              "stringRegexp": "#72f088",
              "markupList": "#fbd669",
              "markupHeading": "#409eff",
              "markupItalic": "#f0f3f6",
              "markupBold": "#f0f3f6",
              "markupDeletedText": "#ffdedb",
              "markupDeletedBg": "#cc1421",
              "markupInsertedText": "#acf7b6",
              "markupInsertedBg": "#007728",
              "markupChangedText": "#ffe1b4",
              "markupChangedBg": "#a74c00",
              "markupIgnoredText": "#f0f3f6",
              "markupIgnoredBg": "#318bf8",
              "metaDiffRange": "#dbb7ff",
              "brackethighlighterAngle": "#bdc4cc",
              "sublimelinterGutterMark": "#7a828e",
              "constantOtherReferenceLink": "#addcff"
            }
          },
          "codemirror": {
            "text": "#f0f3f6",
            "bg": "#0a0c10",
            "guttersBg": "#0a0c10",
            "guttermarkerText": "#0a0c10",
            "guttermarkerSubtleText": "#7a828e",
            "linenumberText": "#f0f3f6",
            "cursor": "#f0f3f6",
            "selectionBg": "rgba(64,158,255,0.4)",
            "activelineBg": "rgba(158,167,179,0.1)",
            "matchingbracketText": "#f0f3f6",
            "linesBg": "#0a0c10",
            "syntax": {
              "comment": "#bdc4cc",
              "constant": "#91cbff",
              "entity": "#dbb7ff",
              "keyword": "#ff9492",
              "storage": "#ff9492",
              "string": "#addcff",
              "support": "#91cbff",
              "variable": "#ffb757"
            }
          },
          "checks": {
            "bg": "#010409",
            "textPrimary": "#f0f3f6",
            "textSecondary": "#f0f3f6",
            "textLink": "#71b7ff",
            "btnIcon": "#f0f3f6",
            "btnHoverIcon": "#f0f3f6",
            "btnHoverBg": "rgba(158,167,179,0.1)",
            "inputText": "#f0f3f6",
            "inputPlaceholderText": "#7a828e",
            "inputFocusText": "#f0f3f6",
            "inputBg": "#272b33",
            "donutError": "#ff6a69",
            "donutPending": "#f0b72f",
            "donutSuccess": "#09b43a",
            "donutNeutral": "#bdc4cc",
            "dropdownText": "#f0f3f6",
            "dropdownBg": "#272b33",
            "dropdownBorder": "#7a828e",
            "dropdownShadow": "rgba(1,4,9,0.3)",
            "dropdownHoverText": "#f0f3f6",
            "dropdownHoverBg": "rgba(158,167,179,0.1)",
            "dropdownBtnHoverText": "#f0f3f6",
            "dropdownBtnHoverBg": "rgba(158,167,179,0.1)",
            "scrollbarThumbBg": "rgba(158,167,179,0.4)",
            "headerLabelText": "#f0f3f6",
            "headerLabelOpenText": "#f0f3f6",
            "headerBorder": "#7a828e",
            "headerIcon": "#f0f3f6",
            "lineText": "#f0f3f6",
            "lineNumText": "#7a828e",
            "lineTimestampText": "#7a828e",
            "lineHoverBg": "rgba(158,167,179,0.1)",
            "lineSelectedBg": "rgba(64,158,255,0.15)",
            "lineSelectedNumText": "#71b7ff",
            "lineDtFmText": "#0a0c10",
            "lineDtFmBg": "#e09b13",
            "gateBg": "rgba(224,155,19,0.15)",
            "gateText": "#f0f3f6",
            "gateWaitingText": "#f0b72f",
            "stepHeaderOpenBg": "#272b33",
            "stepErrorText": "#ff6a69",
            "stepWarningText": "#f0b72f",
            "loglineText": "#f0f3f6",
            "loglineNumText": "#7a828e",
            "loglineDebugText": "#b780ff",
            "loglineErrorText": "#f0f3f6",
            "loglineErrorNumText": "#7a828e",
            "loglineErrorBg": "rgba(255,106,105,0.15)",
            "loglineWarningText": "#f0f3f6",
            "loglineWarningNumText": "#f0b72f",
            "loglineWarningBg": "rgba(224,155,19,0.15)",
            "loglineCommandText": "#71b7ff",
            "loglineSectionText": "#26cd4d",
            "ansi": {
              "black": "#0a0c10",
              "blackBright": "#272b33",
              "white": "#d9dee3",
              "whiteBright": "#d9dee3",
              "gray": "#9ea7b3",
              "red": "#ff9492",
              "redBright": "#ffb1af",
              "green": "#26cd4d",
              "greenBright": "#4ae168",
              "yellow": "#f0b72f",
              "yellowBright": "#f7c843",
              "blue": "#71b7ff",
              "blueBright": "#91cbff",
              "magenta": "#cb9eff",
              "magentaBright": "#dbb7ff",
              "cyan": "#76e3ea",
              "cyanBright": "#b3f0ff"
            }
          },
          "mktg": {
            "success": "rgba(9,180,58,1)",
            "info": "rgba(64,158,255,1)",
            "bgShadeGradient": {
              "top": "rgba(1,4,9,0.065)",
              "bottom": "rgba(1,4,9,0)"
            },
            "btn": {
              "bg": {
                "top": "hsla(228,82%,66%,1)",
                "bottom": "#4969ed"
              },
              "bgOverlay": {
                "top": "hsla(228,74%,59%,1)",
                "bottom": "#3355e0"
              },
              "text": "#ffffff",
              "primary": {
                "bg": {
                  "top": "hsla(137,56%,46%,1)",
                  "bottom": "#2ea44f"
                },
                "bgOverlay": {
                  "top": "hsla(134,60%,38%,1)",
                  "bottom": "#22863a"
                },
                "text": "#ffffff"
              },
              "enterprise": {
                "bg": {
                  "top": "hsla(249,100%,72%,1)",
                  "bottom": "#6f57ff"
                },
                "bgOverlay": {
                  "top": "hsla(248,65%,63%,1)",
                  "bottom": "#614eda"
                },
                "text": "#ffffff"
              },
              "outline": {
                "text": "#ffffff",
                "border": "rgba(255,255,255,0.3)",
                "hover": {
                  "text": "#ffffff",
                  "border": "rgba(255,255,255,0.5)"
                },
                "focus": {
                  "border": "#ffffff",
                  "borderInset": "rgba(255,255,255,0.5)"
                }
              },
              "dark": {
                "text": "#ffffff",
                "border": "rgba(255,255,255,0.3)",
                "hover": {
                  "text": "#ffffff",
                  "border": "rgba(255,255,255,0.5)"
                },
                "focus": {
                  "border": "#ffffff",
                  "borderInset": "rgba(255,255,255,0.5)"
                }
              }
            }
          },
          "avatar": {
            "bg": "rgba(255,255,255,0.1)",
            "border": "rgba(255,255,255,0.9)",
            "stackFade": "#525964",
            "stackFadeMore": "#272b33"
          },
          "header": {
            "text": "rgba(255,255,255,0.7)",
            "bg": "#272b33",
            "logo": "#ffffff"
          },
          "headerSearch": {
            "bg": "#0a0c10",
            "border": "#525964"
          },
          "ansi": {
            "black": "#7a828e",
            "blackBright": "#9ea7b3",
            "white": "#d9dee3",
            "whiteBright": "#ffffff",
            "gray": "#9ea7b3",
            "red": "#ff9492",
            "redBright": "#ffb1af",
            "green": "#26cd4d",
            "greenBright": "#4ae168",
            "yellow": "#f0b72f",
            "yellowBright": "#f7c843",
            "blue": "#71b7ff",
            "blueBright": "#91cbff",
            "magenta": "#cb9eff",
            "magentaBright": "#dbb7ff",
            "cyan": "#39c5cf",
            "cyanBright": "#56d4dd"
          },
          "btn": {
            "text": "#f0f3f6",
            "bg": "#272b33",
            "border": "#7a828e",
            "hoverBg": "#525964",
            "hoverBorder": "#bdc4cc",
            "activeBg": "hsla(217,10%,33%,1)",
            "activeBorder": "#9ea7b3",
            "selectedBg": "rgba(82,89,100,0.9)",
            "focusBg": "#272b33",
            "focusBorder": "#bdc4cc",
            "counterBg": "#525964",
            "primary": {
              "text": "#0a0c10",
              "bg": "#09b43a",
              "border": "#4ae168",
              "hoverBg": "#26cd4d",
              "hoverBorder": "#4ae168",
              "selectedBg": "#09b43a",
              "disabledText": "rgba(10,12,16,0.5)",
              "disabledBg": "rgba(9,180,58,0.6)",
              "disabledBorder": "rgba(74,225,104,0.4)",
              "focusBg": "#09b43a",
              "focusBorder": "#7a828e",
              "icon": "#0a0c10",
              "counterBg": "rgba(1,4,9,0.15)"
            },
            "outline": {
              "text": "#71b7ff",
              "hoverText": "#71b7ff",
              "hoverBg": "#525964",
              "hoverBorder": "#7a828e",
              "hoverCounterBg": "rgba(255,255,255,0.2)",
              "selectedText": "#ffffff",
              "selectedBg": "#2672f3",
              "selectedBorder": "#7a828e",
              "disabledText": "rgba(113,183,255,0.5)",
              "disabledBg": "#0a0c10",
              "disabledCounterBg": "rgba(64,158,255,0.05)",
              "focusBorder": "#7a828e",
              "counterBg": "rgba(64,158,255,0.1)"
            },
            "danger": {
              "text": "#ff6a69",
              "hoverText": "#0a0c10",
              "hoverBg": "#ff6a69",
              "hoverBorder": "#ff6a69",
              "hoverIcon": "#0a0c10",
              "hoverCounterBg": "rgba(1,4,9,0.15)",
              "selectedText": "#ffffff",
              "selectedBg": "#ff4445",
              "selectedBorder": "#ff9492",
              "disabledText": "rgba(255,106,105,0.5)",
              "disabledBg": "#0a0c10",
              "disabledCounterBg": "rgba(255,106,105,0.05)",
              "focusBorder": "#ff6a69",
              "counterBg": "rgba(1,4,9,0.15)",
              "icon": "#ff6a69"
            }
          },
          "fg": {
            "default": "#f0f3f6",
            "muted": "#f0f3f6",
            "subtle": "#7a828e",
            "onEmphasis": "#0a0c10"
          },
          "canvas": {
            "default": "#0a0c10",
            "overlay": "#272b33",
            "inset": "#010409",
            "subtle": "#272b33"
          },
          "neutral": {
            "emphasisPlus": "#ffffff",
            "emphasis": "#9ea7b3",
            "muted": "rgba(158,167,179,0.4)",
            "subtle": "rgba(158,167,179,0.1)"
          },
          "accent": {
            "fg": "#71b7ff",
            "emphasis": "#409eff",
            "muted": "#409eff",
            "subtle": "rgba(64,158,255,0.15)"
          },
          "success": {
            "fg": "#26cd4d",
            "emphasis": "#09b43a",
            "muted": "#09b43a",
            "subtle": "rgba(9,180,58,0.15)"
          },
          "attention": {
            "fg": "#f0b72f",
            "emphasis": "#e09b13",
            "muted": "#e09b13",
            "subtle": "rgba(224,155,19,0.15)"
          },
          "severe": {
            "fg": "#e7811d",
            "emphasis": "#e7811d",
            "muted": "#e7811d",
            "subtle": "rgba(231,129,29,0.15)"
          },
          "danger": {
            "fg": "#ff6a69",
            "emphasis": "#ff6a69",
            "muted": "#ff6a69",
            "subtle": "rgba(255,106,105,0.15)"
          },
          "done": {
            "fg": "#b780ff",
            "emphasis": "#b87fff",
            "muted": "#b780ff",
            "subtle": "rgba(183,128,255,0.15)"
          },
          "sponsors": {
            "fg": "#ef6eb1",
            "emphasis": "#ef6eb1",
            "muted": "#ef6eb1",
            "subtle": "rgba(239,110,177,0.15)"
          },
          "primer": {
            "canvas": {
              "backdrop": "rgba(1,4,9,0.8)",
              "sticky": "rgba(10,12,16,0.95)"
            },
            "border": {
              "active": "#FF967D",
              "contrast": "rgba(255,255,255,0.2)"
            }
          }
        },
        "shadows": {
          "shadow": {
            "highlight": "0 0 transparent",
            "inset": "0 0 transparent",
            "small": "0 0 transparent",
            "medium": "0 3px 6px #010409",
            "large": "0 8px 24px #010409",
            "extraLarge": "0 12px 48px #010409"
          },
          "state": {
            "focus": {
              "shadow": "0 0 0 3px #1e60d5"
            }
          },
          "autocomplete": {
            "shadow": "0 3px 6px #010409"
          },
          "dropdown": {
            "shadow": "0 8px 24px #010409"
          },
          "input": {
            "shadow": "0 0 transparent"
          },
          "toast": {
            "shadow": "0 8px 24px #010409"
          },
          "selectMenu": {
            "shadow": "0 8px 24px #010409"
          },
          "checks": {
            "inputShadow": "0 0 0 1px (obj) => get_1.default(obj, path)"
          },
          "avatar": {
            "childShadow": "-2px -2px 0 #0a0c10"
          },
          "overlay": {
            "shadow": "0 0 0 1px #525964, 0 16px 32px rgba(1,4,9,0.85)"
          },
          "btn": {
            "shadow": "0 0 transparent",
            "insetShadow": "0 0 transparent",
            "focusShadow": "0 0 0 3px rgba(189,196,204,0.3)",
            "shadowActive": "inset 0 0.15em 0.3em rgba(1,4,9,0.15)",
            "shadowInputFocus": "0 0 0 0.2em rgba(64,158,255,0.3)",
            "primary": {
              "shadow": "0 0 transparent",
              "insetShadow": "0 0 transparent",
              "selectedShadow": "0 0 transparent",
              "focusShadow": "0 0 0 3px rgba(46,164,79,0.4)"
            },
            "outline": {
              "hoverShadow": "0 1px 0 rgba(1,4,9,0.1)",
              "hoverInsetShadow": "inset 0 1px 0 rgba(255,255,255,0.03)",
              "selectedShadow": "0 0 transparent",
              "focusShadow": "0 0 0 3px rgba(49,139,248,0.4)"
            },
            "danger": {
              "hoverShadow": "0 0 transparent",
              "hoverInsetShadow": "0 0 transparent",
              "selectedShadow": "0 0 transparent",
              "focusShadow": "0 0 0 3px rgba(255,106,105,0.4)"
            }
          },
          "primer": {
            "shadow": {
              "highlight": "0 0 transparent",
              "inset": "0 0 transparent",
              "focus": "0 0 0 3px #1e60d5"
            }
          }
        }
      },
      "dark_protanopia": {
        "colors": {
          "auto": {
            "black": "#f0f6fc",
            "white": "#010409",
            "gray": ["#0d1117", "#161b22", "#21262d", "#30363d", "#484f58", "#6e7681", "#8b949e", "#b1bac4", "#c9d1d9", "#f0f6fc"],
            "blue": ["#051d4d", "#0c2d6b", "#0d419d", "#1158c7", "#1f6feb", "#388bfd", "#58a6ff", "#79c0ff", "#a5d6ff", "#cae8ff"],
            "green": ["#041843", "#0a2861", "#0b3c92", "#0f53bc", "#1d69e0", "#1585fd", "#42a0ff", "#66baff", "#83d4ff", "#a0e8ff"],
            "yellow": ["#341a00", "#4b2900", "#693e00", "#845306", "#9e6a03", "#bb8009", "#d29922", "#e3b341", "#f2cc60", "#f8e3a1"],
            "orange": ["#3d1300", "#5a1e02", "#762d0a", "#9b4215", "#bd561d", "#db6d28", "#f0883e", "#ffa657", "#ffc680", "#ffdfb6"],
            "red": ["#292100", "#452f00", "#633e00", "#865401", "#a66900", "#c38000", "#d69a00", "#e6b716", "#ecd334", "#f0ec59"],
            "purple": ["#271052", "#3c1e70", "#553098", "#6e40c9", "#8957e5", "#a371f7", "#bc8cff", "#d2a8ff", "#e2c5ff", "#eddeff"],
            "pink": ["#42062a", "#5e103e", "#7d2457", "#9e3670", "#bf4b8a", "#db61a2", "#f778ba", "#ff9bce", "#ffbedd", "#ffdaec"]
          },
          "text": {
            "primary": "#c9d1d9",
            "secondary": "#8b949e",
            "tertiary": "#8b949e",
            "placeholder": "#484f58",
            "disabled": "#8b949e",
            "inverse": "#f0f6fc",
            "link": "#58a6ff",
            "danger": "#c38000",
            "success": "#42a0ff",
            "warning": "#d29922",
            "white": "#f0f6fc"
          },
          "icon": {
            "primary": "#c9d1d9",
            "secondary": "#8b949e",
            "tertiary": "#8b949e",
            "info": "#58a6ff",
            "danger": "#c38000",
            "success": "#42a0ff",
            "warning": "#d29922"
          },
          "border": {
            "primary": "#30363d",
            "secondary": "#21262d",
            "tertiary": "#30363d",
            "overlay": "#30363d",
            "inverse": "#f0f6fc",
            "info": "#1f6feb",
            "danger": "#a66900",
            "success": "#1d69e0",
            "warning": "#9e6a03",
            "default": "#30363d",
            "muted": "#21262d",
            "subtle": "rgba(240,246,252,0.1)"
          },
          "bg": {
            "canvas": "#0d1117",
            "canvasMobile": "rgba(0,0,0,0)",
            "canvasInverse": "#6e7681",
            "canvasInset": "#010409",
            "primary": "#0d1117",
            "secondary": "#161b22",
            "tertiary": "#161b22",
            "overlay": "#161b22",
            "backdrop": "rgba(1,4,9,0.8)",
            "info": "rgba(56,139,253,0.15)",
            "infoInverse": "#1f6feb",
            "danger": "rgba(195,128,0,0.15)",
            "dangerInverse": "#a66900",
            "success": "rgba(21,133,253,0.15)",
            "successInverse": "#1d69e0",
            "warning": "rgba(187,128,9,0.15)",
            "warningInverse": "#9e6a03"
          },
          "state": {
            "hover": {
              "primaryBg": "#1f6feb",
              "primaryBorder": "#1f6feb",
              "primaryText": "#f0f6fc",
              "primaryIcon": "#f0f6fc",
              "secondaryBg": "rgba(110,118,129,0.1)",
              "secondaryBorder": "rgba(110,118,129,0.1)"
            },
            "selected": {
              "primaryBg": "#1f6feb",
              "primaryBorder": "#1f6feb",
              "primaryText": "#f0f6fc",
              "primaryIcon": "#f0f6fc"
            },
            "focus": {
              "border": "#1f6feb"
            }
          },
          "fade": {
            "fg10": "rgba(240,246,252,0.1)",
            "fg15": "rgba(240,246,252,0.15)",
            "fg30": "rgba(240,246,252,0.3)",
            "fg50": "rgba(240,246,252,0.5)",
            "fg70": "rgba(240,246,252,0.7)",
            "fg85": "rgba(240,246,252,0.85)",
            "black10": "rgba(1,4,9,0.1)",
            "black15": "rgba(1,4,9,0.15)",
            "black30": "rgba(1,4,9,0.3)",
            "black50": "rgba(1,4,9,0.5)",
            "black70": "rgba(1,4,9,0.7)",
            "black85": "rgba(1,4,9,0.85)",
            "white10": "rgba(240,246,252,0.1)",
            "white15": "rgba(240,246,252,0.15)",
            "white30": "rgba(240,246,252,0.3)",
            "white50": "rgba(240,246,252,0.5)",
            "white70": "rgba(240,246,252,0.7)",
            "white85": "rgba(240,246,252,0.85)"
          },
          "alert": {
            "info": {
              "text": "#c9d1d9",
              "icon": "#58a6ff",
              "bg": "rgba(56,139,253,0.15)",
              "border": "rgba(56,139,253,0.4)"
            },
            "warn": {
              "text": "#c9d1d9",
              "icon": "#d29922",
              "bg": "rgba(187,128,9,0.15)",
              "border": "rgba(187,128,9,0.4)"
            },
            "error": {
              "text": "#c9d1d9",
              "icon": "#c38000",
              "bg": "rgba(195,128,0,0.15)",
              "border": "rgba(195,128,0,0.4)"
            },
            "success": {
              "text": "#c9d1d9",
              "icon": "#42a0ff",
              "bg": "rgba(21,133,253,0.15)",
              "border": "rgba(21,133,253,0.4)"
            }
          },
          "autocomplete": {
            "rowBorder": "#21262d"
          },
          "blankslate": {
            "icon": "#8b949e"
          },
          "counter": {
            "text": "#c9d1d9",
            "bg": "rgba(110,118,129,0.4)",
            "primary": {
              "text": "#f0f6fc",
              "bg": "#6e7681"
            },
            "secondary": {
              "text": "#8b949e",
              "bg": "rgba(110,118,129,0.1)"
            }
          },
          "box": {
            "blueBorder": "rgba(56,139,253,0.4)",
            "rowYellowBg": "rgba(187,128,9,0.15)",
            "rowBlueBg": "rgba(56,139,253,0.15)",
            "headerBlueBg": "rgba(56,139,253,0.15)",
            "headerBlueBorder": "rgba(56,139,253,0.4)",
            "borderInfo": "rgba(56,139,253,0.4)",
            "bgInfo": "rgba(56,139,253,0.15)",
            "borderWarning": "rgba(187,128,9,0.4)",
            "bgWarning": "rgba(187,128,9,0.15)"
          },
          "branchName": {
            "text": "#8b949e",
            "icon": "#8b949e",
            "bg": "rgba(56,139,253,0.15)",
            "link": {
              "text": "#58a6ff",
              "icon": "#58a6ff",
              "bg": "rgba(56,139,253,0.15)"
            }
          },
          "markdown": {
            "codeBg": "rgba(110,118,129,0.4)",
            "frameBorder": "#30363d",
            "blockquoteBorder": "#30363d",
            "tableBorder": "#30363d",
            "tableTrBorder": "#21262d"
          },
          "filterItem": {
            "barBg": "rgba(110,118,129,0.1)"
          },
          "hiddenTextExpander": {
            "bg": "rgba(110,118,129,0.4)",
            "bgHover": "rgba(56,139,253,0.4)"
          },
          "dragAndDrop": {
            "border": "#30363d"
          },
          "uploadEnabled": {
            "border": "#30363d",
            "borderFocused": "#1f6feb"
          },
          "previewableCommentForm": {
            "border": "#30363d"
          },
          "verifiedBadge": {
            "text": "#42a0ff",
            "bg": "#0d1117",
            "border": "#30363d"
          },
          "socialCount": {
            "bg": "#0d1117"
          },
          "tooltip": {
            "text": "#f0f6fc",
            "bg": "#6e7681"
          },
          "filesExplorerIcon": "#58a6ff",
          "hlAuthorBg": "rgba(56,139,253,0.15)",
          "hlAuthorBorder": "rgba(56,139,253,0.4)",
          "logoSubdued": "rgba(110,118,129,0.4)",
          "discussionBorder": "rgba(21,133,253,0.4)",
          "discussionBgSuccess": "#1d69e0",
          "actionsWorkflowTableStickyBg": "rgba(13,17,23,0.95)",
          "repoLanguageColorBorder": "rgba(240,246,252,0.2)",
          "codeSelectionBg": "rgba(56,139,253,0.4)",
          "highlight": {
            "text": "#c9d1d9",
            "bg": "rgba(187,128,9,0.15)"
          },
          "blob": {
            "lineHighlightBg": "rgba(187,128,9,0.15)",
            "lineHighlightBorder": "rgba(187,128,9,0.4)"
          },
          "topicTag": {
            "text": "#58a6ff",
            "bg": "rgba(56,139,253,0.15)",
            "hoverBg": "#1f6feb",
            "activeBg": "rgba(56,139,253,0.15)",
            "border": "rgba(0,0,0,0)"
          },
          "footerInvertocat": {
            "octicon": "#484f58",
            "octiconHover": "#8b949e"
          },
          "label": {
            "border": "#30363d",
            "primary": {
              "text": "#c9d1d9",
              "border": "#6e7681"
            },
            "secondary": {
              "text": "#8b949e",
              "border": "#30363d"
            },
            "info": {
              "text": "#58a6ff",
              "border": "#1f6feb"
            },
            "success": {
              "text": "#42a0ff",
              "border": "#1d69e0"
            },
            "warning": {
              "text": "#d29922",
              "border": "#9e6a03"
            },
            "danger": {
              "text": "#c38000",
              "border": "#a66900"
            },
            "orange": {
              "text": "#db6d28",
              "border": "#bd561d"
            }
          },
          "input": {
            "bg": "#0d1117",
            "contrastBg": "#010409",
            "border": "#30363d",
            "disabledBorder": "#30363d",
            "warningBorder": "#9e6a03",
            "errorBorder": "#a66900",
            "tooltip": {
              "success": {
                "text": "#c9d1d9",
                "bg": "rgba(21,133,253,0.15)",
                "border": "rgba(21,133,253,0.4)"
              },
              "warning": {
                "text": "#c9d1d9",
                "bg": "rgba(187,128,9,0.15)",
                "border": "rgba(187,128,9,0.4)"
              },
              "error": {
                "text": "#c9d1d9",
                "bg": "rgba(195,128,0,0.15)",
                "border": "rgba(195,128,0,0.4)"
              }
            },
            "disabledBg": "rgba(110,118,129,0)"
          },
          "toast": {
            "text": "#c9d1d9",
            "bg": "#0d1117",
            "border": "#30363d",
            "icon": "#f0f6fc",
            "iconBg": "#1f6feb",
            "iconBorder": "rgba(0,0,0,0)",
            "success": {
              "text": "#c9d1d9",
              "border": "#30363d",
              "icon": "#f0f6fc",
              "iconBg": "#1d69e0",
              "iconBorder": "rgba(0,0,0,0)"
            },
            "warning": {
              "text": "#c9d1d9",
              "border": "#30363d",
              "icon": "#c9d1d9",
              "iconBg": "#9e6a03",
              "iconBorder": "rgba(0,0,0,0)"
            },
            "danger": {
              "text": "#c9d1d9",
              "border": "#30363d",
              "icon": "#f0f6fc",
              "iconBg": "#a66900",
              "iconBorder": "rgba(0,0,0,0)"
            },
            "loading": {
              "text": "#c9d1d9",
              "border": "#30363d",
              "icon": "#f0f6fc",
              "iconBg": "#6e7681",
              "iconBorder": "rgba(0,0,0,0)"
            }
          },
          "timeline": {
            "text": "#8b949e",
            "badgeSuccessBorder": "rgba(0,0,0,0)",
            "targetBadgeBorder": "#1f6feb",
            "targetBadgeShadow": "rgba(56,139,253,0.4)",
            "badgeBg": "#21262d"
          },
          "diffstat": {
            "neutralBg": "rgba(110,118,129,0.4)",
            "neutralBorder": "rgba(240,246,252,0.1)",
            "deletionBorder": "rgba(240,246,252,0.1)",
            "additionBorder": "rgba(240,246,252,0.1)",
            "deletionBg": "#a66900",
            "additionBg": "#42a0ff"
          },
          "diff": {
            "addition": {
              "text": "#c9d1d9",
              "bg": "rgba(21,133,253,0.15)",
              "border": "rgba(21,133,253,0.4)"
            },
            "deletion": {
              "text": "#c9d1d9",
              "bg": "rgba(195,128,0,0.15)",
              "border": "rgba(195,128,0,0.4)"
            },
            "change": {
              "text": "#d29922",
              "bg": "rgba(187,128,9,0.15)",
              "border": "rgba(187,128,9,0.4)"
            }
          },
          "mergeBox": {
            "successIconBg": "#1d69e0",
            "successIconText": "#f0f6fc",
            "successIconBorder": "rgba(0,0,0,0)",
            "successIndicatorBg": "#1d69e0",
            "successIndicatorBorder": "rgba(0,0,0,0)",
            "mergedIconBg": "#8957e5",
            "mergedIconText": "#f0f6fc",
            "mergedIconBorder": "rgba(0,0,0,0)",
            "mergedBoxBorder": "#8957e5",
            "neutralIconBg": "#6e7681",
            "neutralIconText": "#f0f6fc",
            "neutralIconBorder": "rgba(0,0,0,0)",
            "neutralIndicatorBg": "#6e7681",
            "neutralIndicatorBorder": "rgba(0,0,0,0)",
            "warningIconBg": "#9e6a03",
            "warningIconText": "#f0f6fc",
            "warningIconBorder": "rgba(0,0,0,0)",
            "warningBoxBorder": "#9e6a03",
            "warningMergeHighlight": "rgba(0,0,0,0)",
            "errorIconBg": "#a66900",
            "errorIconText": "#f0f6fc",
            "errorIconBorder": "rgba(0,0,0,0)",
            "errorIndicatorBg": "#a66900",
            "errorIndicatorBorder": "rgba(0,0,0,0)"
          },
          "underlinenav": {
            "border": "rgba(0,0,0,0)",
            "borderHover": "rgba(110,118,129,0.4)",
            "borderActive": "#F78166",
            "text": "#c9d1d9",
            "textHover": "#c9d1d9",
            "textActive": "#c9d1d9",
            "icon": "#484f58",
            "iconHover": "#484f58",
            "iconActive": "#c9d1d9",
            "counterText": "#c9d1d9",
            "counterBg": "rgba(110,118,129,0.4)"
          },
          "selectMenu": {
            "borderSecondary": "#21262d",
            "backdropBg": "rgba(1,4,9,0.8)",
            "backdropBorder": "#484f58",
            "tapHighlight": "rgba(48,54,61,0.5)",
            "tapFocusBg": "#0c2d6b"
          },
          "sidenav": {
            "borderActive": "#F78166",
            "selectedBg": "#21262d"
          },
          "menu": {
            "headingText": "#c9d1d9",
            "borderActive": "#F78166",
            "bgActive": "#161b22"
          },
          "project": {
            "cardBg": "#161b22",
            "headerBg": "#0d1117",
            "sidebarBg": "#161b22",
            "gradientIn": "#161b22",
            "gradientOut": "rgba(22,27,34,0)"
          },
          "prState": {
            "draft": {
              "text": "#f0f6fc",
              "bg": "#6e7681",
              "border": "rgba(0,0,0,0)"
            },
            "open": {
              "text": "#f0f6fc",
              "bg": "#1d69e0",
              "border": "rgba(0,0,0,0)"
            },
            "merged": {
              "text": "#f0f6fc",
              "bg": "#8957e5",
              "border": "rgba(0,0,0,0)"
            },
            "closed": {
              "text": "#f0f6fc",
              "bg": "#a66900",
              "border": "rgba(0,0,0,0)"
            }
          },
          "diffBlob": {
            "numText": "#484f58",
            "numHoverText": "#c9d1d9",
            "addition": {
              "numHoverText": "#c9d1d9",
              "numText": "#c9d1d9",
              "fg": "#c9d1d9",
              "numBg": "rgba(66,160,255,0.3)",
              "lineBg": "rgba(21,133,253,0.15)",
              "wordBg": "rgba(21,133,253,0.4)"
            },
            "deletion": {
              "numHoverText": "#c9d1d9",
              "numText": "#c9d1d9",
              "fg": "#c9d1d9",
              "numBg": "rgba(195,128,0,0.3)",
              "lineBg": "rgba(195,128,0,0.15)",
              "wordBg": "rgba(195,128,0,0.4)"
            },
            "hunk": {
              "text": "#8b949e",
              "numBg": "rgba(56,139,253,0.4)",
              "lineBg": "rgba(56,139,253,0.15)"
            },
            "emptyBlockBg": "rgba(110,118,129,0.1)",
            "selectedLineHighlightBg": "rgba(187,128,9,0.15)",
            "selectedLineHighlightBorder": "rgba(187,128,9,0.4)",
            "expander": {
              "hoverIcon": "#f0f6fc",
              "hoverBg": "#1f6feb",
              "icon": "#8b949e"
            },
            "commentButton": {
              "icon": "#f0f6fc",
              "bg": "#1f6feb",
              "gradientBg": "rgba(0,0,0,0)"
            }
          },
          "globalNav": {
            "logo": "#f0f6fc",
            "bg": "#161b22",
            "text": "#c9d1d9",
            "icon": "#c9d1d9",
            "inputBg": "#0d1117",
            "inputBorder": "#21262d",
            "inputIcon": "#21262d",
            "inputPlaceholder": "#484f58"
          },
          "introShelf": {
            "gradientLeft": "rgba(56,139,253,0.15)",
            "gradientRight": "rgba(21,133,253,0.15)",
            "gradientIn": "#0d1117",
            "gradientOut": "rgba(240,246,252,0)"
          },
          "canvasDefaultTransparent": "rgba(13,17,23,0)",
          "marketingIcon": {
            "primary": "#79c0ff",
            "secondary": "#1f6feb"
          },
          "searchKeyword": {
            "hl": "rgba(210,153,34,0.4)"
          },
          "prettylights": {
            "syntax": {
              "comment": "#8b949e",
              "constant": "#79c0ff",
              "entity": "#d2a8ff",
              "storageModifierImport": "#c9d1d9",
              "entityTag": "#83d4ff",
              "keyword": "#d69a00",
              "string": "#a5d6ff",
              "variable": "#ffa657",
              "brackethighlighterUnmatched": "#c38000",
              "invalidIllegalText": "#f0f6fc",
              "invalidIllegalBg": "#633e00",
              "carriageReturnText": "#f0f6fc",
              "carriageReturnBg": "#865401",
              "stringRegexp": "#83d4ff",
              "markupList": "#f2cc60",
              "markupHeading": "#1f6feb",
              "markupItalic": "#c9d1d9",
              "markupBold": "#c9d1d9",
              "markupDeletedText": "#f0ec59",
              "markupDeletedBg": "#452f00",
              "markupInsertedText": "#a0e8ff",
              "markupInsertedBg": "#0a2861",
              "markupChangedText": "#ffdfb6",
              "markupChangedBg": "#5a1e02",
              "markupIgnoredText": "#c9d1d9",
              "markupIgnoredBg": "#1158c7",
              "metaDiffRange": "#d2a8ff",
              "brackethighlighterAngle": "#8b949e",
              "sublimelinterGutterMark": "#484f58",
              "constantOtherReferenceLink": "#a5d6ff"
            }
          },
          "codemirror": {
            "text": "#c9d1d9",
            "bg": "#0d1117",
            "guttersBg": "#0d1117",
            "guttermarkerText": "#0d1117",
            "guttermarkerSubtleText": "#484f58",
            "linenumberText": "#8b949e",
            "cursor": "#c9d1d9",
            "selectionBg": "rgba(56,139,253,0.4)",
            "activelineBg": "rgba(110,118,129,0.1)",
            "matchingbracketText": "#c9d1d9",
            "linesBg": "#0d1117",
            "syntax": {
              "comment": "#8b949e",
              "constant": "#79c0ff",
              "entity": "#d2a8ff",
              "keyword": "#d69a00",
              "storage": "#d69a00",
              "string": "#a5d6ff",
              "support": "#79c0ff",
              "variable": "#ffa657"
            }
          },
          "checks": {
            "bg": "#010409",
            "textPrimary": "#c9d1d9",
            "textSecondary": "#8b949e",
            "textLink": "#58a6ff",
            "btnIcon": "#8b949e",
            "btnHoverIcon": "#c9d1d9",
            "btnHoverBg": "rgba(110,118,129,0.1)",
            "inputText": "#8b949e",
            "inputPlaceholderText": "#484f58",
            "inputFocusText": "#c9d1d9",
            "inputBg": "#161b22",
            "donutError": "#c38000",
            "donutPending": "#d29922",
            "donutSuccess": "#1585fd",
            "donutNeutral": "#8b949e",
            "dropdownText": "#c9d1d9",
            "dropdownBg": "#161b22",
            "dropdownBorder": "#30363d",
            "dropdownShadow": "rgba(1,4,9,0.3)",
            "dropdownHoverText": "#c9d1d9",
            "dropdownHoverBg": "rgba(110,118,129,0.1)",
            "dropdownBtnHoverText": "#c9d1d9",
            "dropdownBtnHoverBg": "rgba(110,118,129,0.1)",
            "scrollbarThumbBg": "rgba(110,118,129,0.4)",
            "headerLabelText": "#8b949e",
            "headerLabelOpenText": "#c9d1d9",
            "headerBorder": "#21262d",
            "headerIcon": "#8b949e",
            "lineText": "#8b949e",
            "lineNumText": "#484f58",
            "lineTimestampText": "#484f58",
            "lineHoverBg": "rgba(110,118,129,0.1)",
            "lineSelectedBg": "rgba(56,139,253,0.15)",
            "lineSelectedNumText": "#58a6ff",
            "lineDtFmText": "#f0f6fc",
            "lineDtFmBg": "#9e6a03",
            "gateBg": "rgba(187,128,9,0.15)",
            "gateText": "#8b949e",
            "gateWaitingText": "#d29922",
            "stepHeaderOpenBg": "#161b22",
            "stepErrorText": "#c38000",
            "stepWarningText": "#d29922",
            "loglineText": "#8b949e",
            "loglineNumText": "#484f58",
            "loglineDebugText": "#a371f7",
            "loglineErrorText": "#8b949e",
            "loglineErrorNumText": "#484f58",
            "loglineErrorBg": "rgba(195,128,0,0.15)",
            "loglineWarningText": "#8b949e",
            "loglineWarningNumText": "#d29922",
            "loglineWarningBg": "rgba(187,128,9,0.15)",
            "loglineCommandText": "#58a6ff",
            "loglineSectionText": "#42a0ff",
            "ansi": {
              "black": "#0d1117",
              "blackBright": "#161b22",
              "white": "#b1bac4",
              "whiteBright": "#b1bac4",
              "gray": "#6e7681",
              "red": "#d69a00",
              "redBright": "#e6b716",
              "green": "#42a0ff",
              "greenBright": "#66baff",
              "yellow": "#d29922",
              "yellowBright": "#e3b341",
              "blue": "#58a6ff",
              "blueBright": "#79c0ff",
              "magenta": "#bc8cff",
              "magentaBright": "#d2a8ff",
              "cyan": "#76e3ea",
              "cyanBright": "#b3f0ff"
            }
          },
          "mktg": {
            "success": "rgba(25,119,239,1)",
            "info": "rgba(42,123,243,1)",
            "bgShadeGradient": {
              "top": "rgba(1,4,9,0.065)",
              "bottom": "rgba(1,4,9,0)"
            },
            "btn": {
              "bg": {
                "top": "hsla(228,82%,66%,1)",
                "bottom": "#4969ed"
              },
              "bgOverlay": {
                "top": "hsla(228,74%,59%,1)",
                "bottom": "#3355e0"
              },
              "text": "#f0f6fc",
              "primary": {
                "bg": {
                  "top": "hsla(137,56%,46%,1)",
                  "bottom": "#2ea44f"
                },
                "bgOverlay": {
                  "top": "hsla(134,60%,38%,1)",
                  "bottom": "#22863a"
                },
                "text": "#f0f6fc"
              },
              "enterprise": {
                "bg": {
                  "top": "hsla(249,100%,72%,1)",
                  "bottom": "#6f57ff"
                },
                "bgOverlay": {
                  "top": "hsla(248,65%,63%,1)",
                  "bottom": "#614eda"
                },
                "text": "#f0f6fc"
              },
              "outline": {
                "text": "#f0f6fc",
                "border": "rgba(240,246,252,0.3)",
                "hover": {
                  "text": "#f0f6fc",
                  "border": "rgba(240,246,252,0.5)"
                },
                "focus": {
                  "border": "#f0f6fc",
                  "borderInset": "rgba(240,246,252,0.5)"
                }
              },
              "dark": {
                "text": "#f0f6fc",
                "border": "rgba(240,246,252,0.3)",
                "hover": {
                  "text": "#f0f6fc",
                  "border": "rgba(240,246,252,0.5)"
                },
                "focus": {
                  "border": "#f0f6fc",
                  "borderInset": "rgba(240,246,252,0.5)"
                }
              }
            }
          },
          "avatar": {
            "bg": "rgba(240,246,252,0.1)",
            "border": "rgba(240,246,252,0.1)",
            "stackFade": "#30363d",
            "stackFadeMore": "#21262d"
          },
          "header": {
            "text": "rgba(240,246,252,0.7)",
            "bg": "#161b22",
            "logo": "#f0f6fc"
          },
          "headerSearch": {
            "bg": "#0d1117",
            "border": "#30363d"
          },
          "ansi": {
            "black": "#484f58",
            "blackBright": "#6e7681",
            "white": "#b1bac4",
            "whiteBright": "#f0f6fc",
            "gray": "#6e7681",
            "red": "#d69a00",
            "redBright": "#e6b716",
            "green": "#42a0ff",
            "greenBright": "#66baff",
            "yellow": "#d29922",
            "yellowBright": "#e3b341",
            "blue": "#58a6ff",
            "blueBright": "#79c0ff",
            "magenta": "#bc8cff",
            "magentaBright": "#d2a8ff",
            "cyan": "#39c5cf",
            "cyanBright": "#56d4dd"
          },
          "btn": {
            "text": "#c9d1d9",
            "bg": "#21262d",
            "border": "rgba(240,246,252,0.1)",
            "hoverBg": "#30363d",
            "hoverBorder": "#8b949e",
            "activeBg": "hsla(212,12%,18%,1)",
            "activeBorder": "#6e7681",
            "selectedBg": "#161b22",
            "focusBg": "#21262d",
            "focusBorder": "#8b949e",
            "counterBg": "#30363d",
            "primary": {
              "text": "#ffffff",
              "bg": "#1d69e0",
              "border": "rgba(240,246,252,0.1)",
              "hoverBg": "#1585fd",
              "hoverBorder": "rgba(240,246,252,0.1)",
              "selectedBg": "#1d69e0",
              "disabledText": "rgba(240,246,252,0.5)",
              "disabledBg": "rgba(29,105,224,0.6)",
              "disabledBorder": "rgba(240,246,252,0.1)",
              "focusBg": "#1d69e0",
              "focusBorder": "rgba(240,246,252,0.1)",
              "icon": "#f0f6fc",
              "counterBg": "rgba(240,246,252,0.2)"
            },
            "outline": {
              "text": "#58a6ff",
              "hoverText": "#58a6ff",
              "hoverBg": "#30363d",
              "hoverBorder": "rgba(240,246,252,0.1)",
              "hoverCounterBg": "rgba(240,246,252,0.2)",
              "selectedText": "#f0f6fc",
              "selectedBg": "#0d419d",
              "selectedBorder": "rgba(240,246,252,0.1)",
              "disabledText": "rgba(88,166,255,0.5)",
              "disabledBg": "#0d1117",
              "disabledCounterBg": "rgba(31,111,235,0.05)",
              "focusBorder": "rgba(240,246,252,0.1)",
              "counterBg": "rgba(31,111,235,0.1)"
            },
            "danger": {
              "text": "#c38000",
              "hoverText": "#f0f6fc",
              "hoverBg": "#a66900",
              "hoverBorder": "#c38000",
              "hoverIcon": "#f0f6fc",
              "hoverCounterBg": "rgba(255,255,255,0.2)",
              "selectedText": "#ffffff",
              "selectedBg": "#865401",
              "selectedBorder": "#d69a00",
              "disabledText": "rgba(195,128,0,0.5)",
              "disabledBg": "#0d1117",
              "disabledCounterBg": "rgba(166,105,0,0.05)",
              "focusBorder": "#c38000",
              "counterBg": "rgba(166,105,0,0.1)",
              "icon": "#c38000"
            }
          },
          "fg": {
            "default": "#c9d1d9",
            "muted": "#8b949e",
            "subtle": "#484f58",
            "onEmphasis": "#f0f6fc"
          },
          "canvas": {
            "default": "#0d1117",
            "overlay": "#161b22",
            "inset": "#010409",
            "subtle": "#161b22"
          },
          "neutral": {
            "emphasisPlus": "#6e7681",
            "emphasis": "#6e7681",
            "muted": "rgba(110,118,129,0.4)",
            "subtle": "rgba(110,118,129,0.1)"
          },
          "accent": {
            "fg": "#58a6ff",
            "emphasis": "#1f6feb",
            "muted": "rgba(56,139,253,0.4)",
            "subtle": "rgba(56,139,253,0.15)"
          },
          "success": {
            "fg": "#42a0ff",
            "emphasis": "#1d69e0",
            "muted": "rgba(21,133,253,0.4)",
            "subtle": "rgba(21,133,253,0.15)"
          },
          "attention": {
            "fg": "#d29922",
            "emphasis": "#9e6a03",
            "muted": "rgba(187,128,9,0.4)",
            "subtle": "rgba(187,128,9,0.15)"
          },
          "severe": {
            "fg": "#db6d28",
            "emphasis": "#bd561d",
            "muted": "rgba(219,109,40,0.4)",
            "subtle": "rgba(219,109,40,0.15)"
          },
          "danger": {
            "fg": "#c38000",
            "emphasis": "#a66900",
            "muted": "rgba(195,128,0,0.4)",
            "subtle": "rgba(195,128,0,0.15)"
          },
          "done": {
            "fg": "#a371f7",
            "emphasis": "#8957e5",
            "muted": "rgba(163,113,247,0.4)",
            "subtle": "rgba(163,113,247,0.15)"
          },
          "sponsors": {
            "fg": "#db61a2",
            "emphasis": "#bf4b8a",
            "muted": "rgba(219,97,162,0.4)",
            "subtle": "rgba(219,97,162,0.15)"
          },
          "primer": {
            "canvas": {
              "backdrop": "rgba(1,4,9,0.8)",
              "sticky": "rgba(13,17,23,0.95)"
            },
            "border": {
              "active": "#F78166",
              "contrast": "rgba(240,246,252,0.2)"
            }
          }
        },
        "shadows": {
          "shadow": {
            "highlight": "0 0 transparent",
            "inset": "0 0 transparent",
            "small": "0 0 transparent",
            "medium": "0 3px 6px #010409",
            "large": "0 8px 24px #010409",
            "extraLarge": "0 12px 48px #010409"
          },
          "state": {
            "focus": {
              "shadow": "0 0 0 3px #0c2d6b"
            }
          },
          "autocomplete": {
            "shadow": "0 3px 6px #010409"
          },
          "dropdown": {
            "shadow": "0 8px 24px #010409"
          },
          "input": {
            "shadow": "0 0 transparent"
          },
          "toast": {
            "shadow": "0 8px 24px #010409"
          },
          "selectMenu": {
            "shadow": "0 8px 24px #010409"
          },
          "checks": {
            "inputShadow": "0 0 0 1px (obj) => get_1.default(obj, path)"
          },
          "avatar": {
            "childShadow": "-2px -2px 0 #0d1117"
          },
          "overlay": {
            "shadow": "0 0 0 1px #30363d, 0 16px 32px rgba(1,4,9,0.85)"
          },
          "btn": {
            "shadow": "0 0 transparent",
            "insetShadow": "0 0 transparent",
            "focusShadow": "0 0 0 3px rgba(139,148,158,0.3)",
            "shadowActive": "inset 0 0.15em 0.3em rgba(1,4,9,0.15)",
            "shadowInputFocus": "0 0 0 0.2em rgba(31,111,235,0.3)",
            "primary": {
              "shadow": "0 0 transparent",
              "insetShadow": "0 0 transparent",
              "selectedShadow": "0 0 transparent",
              "focusShadow": "0 0 0 3px rgba(46,164,79,0.4)"
            },
            "outline": {
              "hoverShadow": "0 1px 0 rgba(1,4,9,0.1)",
              "hoverInsetShadow": "inset 0 1px 0 rgba(240,246,252,0.03)",
              "selectedShadow": "0 0 transparent",
              "focusShadow": "0 0 0 3px rgba(17,88,199,0.4)"
            },
            "danger": {
              "hoverShadow": "0 0 transparent",
              "hoverInsetShadow": "0 0 transparent",
              "selectedShadow": "0 0 transparent",
              "focusShadow": "0 0 0 3px rgba(195,128,0,0.4)"
            }
          },
          "primer": {
            "shadow": {
              "highlight": "0 0 transparent",
              "inset": "0 0 transparent",
              "focus": "0 0 0 3px #0c2d6b"
            }
          }
        }
      }
    }
  }
};